import type { TranslationKeys } from './fr';

export const es: TranslationKeys = {
  // Menú principal
  menu: {
    spaces: 'Espacios',
    sources: 'Fuentes',
    // V4-FRONT-NAMING-WIZARD-VEILLE 2026-06-03 — "Intereses" partout (revert de V4-NAMING-VEILLE).
    // V4-FRONT-NAMING-THEMATIQUES 2026-06-22 — "Intereses" → "Temáticas" (3er renombrado: Vigilancia→Intereses→Temáticas).
    watch: 'Temáticas',
    positioning: 'Posicionamiento',
    channels: 'Canales',
    newsletter: 'Newsletter',
    automations: 'Automatizaciones',
    posts: 'Publicaciones',
    appearance: 'Apariencia',
    settings: 'Configuración',
    brandConfig: 'Identidad de marca',
    analytics: 'Analíticas',
    engagement: 'Interacción',
    history: 'Historial',
  },

  brandConfig: {
    title: 'Identidad de marca',
    description: 'Tus colores, fuentes y logo — extraídos automáticamente de tu sitio. Tus carruseles e imágenes generados por la IA los reutilizan para mantenerse coherentes con tu marca. Modificables en cualquier momento.',
    landingUrl: 'URL de la landing page',
    landingUrlPlaceholder: 'https://tu-sitio.com',
    reExtract: 'Re-extraer',
    reExtracting: 'Extrayendo…',
    statusPending: 'Extracción en curso…',
    statusFailed: 'Extracción fallida',
    statusFailedRetry: 'Reintentar',
    palette: 'Paleta de colores',
    paletteEmpty: 'Ningún color detectado',
    fonts: 'Fuentes',
    fontsEmpty: 'Ninguna fuente detectada',
    images: 'Imágenes detectadas',
    imagesEmpty: 'Ninguna imagen detectada',
    artisticDirection: 'Dirección artística',
    artisticDirectionPlaceholder: 'Describe el estilo visual deseado…',
    artisticDirectionEmpty: 'Sin dirección artística. Haz clic en editar para añadir una.',
    artisticTagPlaceholder: 'Añade una etiqueta y pulsa Enter…',
    preview: 'Vista previa',
    previewTitle: 'Título de ejemplo',
    previewText: 'Ejemplo: tus carruseles e imágenes reutilizarán estos colores y fuentes.',
    previewCta: 'Botón CTA',
    refreshError: 'Error al actualizar',
    copyColorPrefix: 'Copiar',
    save: 'Guardar',
    saveSuccess: 'Identidad de marca actualizada',
    saveError: 'Error al actualizar',
    copyHex: 'Copiar',
    copied: 'Copiado',
    colorRolePrimary: 'Primario',
    colorRoleSecondary: 'Secundario',
    colorRoleAccent: 'Acento',
    colorRoleBackground: 'Fondo',
    colorRoleText: 'Texto',
    colorRoleMuted: 'Atenuado',
    imageTypeLogo: 'Logo',
    imageTypeHero: 'Imagen principal',
    imageTypeAdditional: 'Imagen adicional',
    noLandingUrl: 'Aún no se ha proporcionado una URL para este espacio. Proporciónala para activar la extracción.',
    // UX fix 20-05 — Modo de entrada manual
    manualModeShow: '¿Sin sitio web? Ingresa manualmente',
    manualModeHide: 'Ocultar entrada manual',
    manualAddColor: 'Añadir un color',
    manualAddFont: 'Añadir una fuente (nombre Google Font o familia)',
    manualAddImage: 'Añadir una imagen (URL pública)',
    manualFontPlaceholder: 'Ej.: Inter, Roboto, Poppins…',
    manualHint: 'Los elementos añadidos aquí se guardan inmediatamente y son utilizados por los agentes de IA.',
    add: 'Añadir',
    remove: 'Eliminar',
    replace: 'Reemplazar',
    invalidHex: 'Formato hex inválido (ej.: #5500FF)',
    invalidImageUrl: 'URL inválida (debe empezar con http(s)://)',
    // V4-BRAND-01 2026-05-29 — panel de error de extracción
    extractionFailed: 'No pudimos analizar tu sitio. Puedes reintentar o configurar manualmente.',
    extractionRetry: 'Reintentar',
    extractionManual: 'Configurar manualmente',
    extractionSlow: 'La extracción está tardando más de lo esperado. Puedes esperar un poco más o reintentar.',
    extractionReset: 'Extracción reiniciada',
    extractionResetError: 'No se pudo reiniciar la extracción',
    // V4-BRAND-02 2026-05-29 — circuit breaker polling
    pollingLost: 'Conexión perdida, reconectando…',
  },

  // Sidebar
  sidebar: {
    account: 'Cuenta',
    logout: 'Cerrar sesión',
    saveChanges: 'Guardar cambios',
    publicationsComingSoon: 'Publicaciones',
    newsletterComingSoon: 'Newsletter - Próximamente',
    historyTooltip: 'Historial de publicaciones',
    switchSpace: 'Cambiar espacio',
  },

  // V4-ANALYTICS-HISTORY — History panel (right sidebar).
  history: {
    title: 'Historial de publicaciones',
    metricViews: 'Vistas',
    metricLikes: 'Me gusta',
    metricComments: 'Comentarios',
    metricShares: 'Compartidos',
    granDaily: 'Diario',
    granWeekly: 'Semanal',
    granMonthly: 'Mensual',
    loading: 'Cargando…',
    empty: 'Aún no hay datos de historial. Las estadísticas aparecerán cuando tus publicaciones se publiquen y se recopilen sus métricas.',
    weekAbbrev: 'Sem',
    topTopics: 'Temas tratados',
    topSources: 'Fuentes principales',
    postsActivity: 'Actividad de publicación',
    totalPosts: 'Total',
    postsLastMonth: 'Último mes',
    postsVariation: 'Variación',
    globalStats: 'Estadísticas globales',
    positioningTitle: 'Posicionamiento',
    improvePositioning: 'Mejorar el posicionamiento',
    noPositioning: 'No hay posicionamiento específico definido para este canal.',
    generatePositioning: 'Generar un posicionamiento',
    positioningSoon: 'Próximamente',
    openPost: 'Abrir publicación',
    noData: 'Sin datos',
    savePositioning: 'Guardar',
    analyticsUnavailable: 'Analíticas no disponibles (complemento Zernio requerido)',
  },

  // Agencia
  agency: {
    myAgency: 'Mi agencia',
    members: 'Miembros',
    billing: 'Facturación',
    roleOwner: 'Propietario',
    roleMember: 'Miembro',
    spaceRoleOwner: 'Propietario',
    spaceRoleEditor: 'Editor',
    spaceRoleViewer: 'Lector',
    spacesTitle: 'Gestión de espacios',
    seatsUsed: 'espacios utilizados',
    createSpace: 'Crear un espacio',
    editSpace: 'Modificar espacio',
    deleteSpace: 'Archivar espacio',
    noClientEmail: 'Sin email de cliente',
    guestEmailsLabel: 'Emails invitados (solo lectura)',
    addGuestEmail: 'Añade un email y pulsa Intro',
    guestEmailsHint: 'Estas personas tendrán acceso de solo lectura a este espacio.',
    invalidEmailFormat: 'Formato de email no válido',
    firstClient: {
      ctaTitle: 'Crea tu primer espacio de cliente',
      ctaDesc: 'Un espacio por cliente: posicionamiento, fuentes y publicaciones propios.',
      title: 'Crear tu primer espacio de cliente',
      subtitle: 'Cada cliente tiene su propio espacio, aislado y configurable.',
      nameLabel: 'Nombre del cliente',
      namePlaceholder: 'Ej.: Panadería Martín',
      inviteLabel: 'Invitar al cliente (solo lectura) — opcional',
      inviteHint: 'Podrá consultar las publicaciones de su espacio sin modificarlas.',
      create: 'Crear el espacio',
      creating: 'Creando…',
      later: 'Más tarde',
      createError: 'No se pudo crear el espacio',
      createdTitle: 'Espacio «{name}» creado',
      createdDesc: 'Configúralo ahora (posicionamiento, fuentes, canales) para generar sus primeras publicaciones.',
      configureNow: 'Configurar ahora',
    },
    upgradeSeats: 'Añadir un asiento',
    spaceQuotaReachedHint: 'Cuota de espacios alcanzada — añade un asiento para crear uno nuevo.',
    addSeatsTitle: 'Añadir asientos',
    addSeatsDesc: 'Selecciona el número de asientos adicionales que deseas añadir a tu suscripción.',
    seatPriceLabel: 'Precio por asiento',
    seatsLabel: 'Asientos',
    addSeatsConfirm: 'Añadir',
    addSeatsSuccess: '¡Asientos añadidos con éxito!',
    confirmArchive: '¿Está seguro de que desea archivar este espacio? Los datos se conservarán durante 30 días.',
    spaceLimitReached: 'Límite de espacios alcanzado para su suscripción.',
    spaceName: 'Nombre del espacio',
    spaceCreated: 'Espacio creado con éxito',
    spaceUpdated: 'Espacio actualizado',
    spaceArchived: 'Espacio archivado',
    downgradeToPro: 'Volver a cuenta Pro',
    downgradeTitle: 'Volver a cuenta Pro',
    downgradeDescription: 'Elija el espacio que desea conservar. Los demás espacios quedarán inaccesibles (recuperables a petición).',
    downgradeKeepLabel: 'Espacio a conservar',
    downgradeConfirm: 'Confirmar el cambio a Pro',
    downgradeSuccess: 'Cuenta cambiada a Pro',
  },

  // Redes sociales y canales
  networks: {
    x: 'X (Twitter)',
    twitter: 'X (Twitter)',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    newsletter: 'Newsletter',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    pinterest: 'Pinterest',
    reddit: 'Reddit',
    googlebusiness: 'Google Business',
    baidu: 'Baidu',
    slack: 'Slack',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    teams: 'Microsoft Teams',
    discord: 'Discord',
    threads: 'Threads',
    bluesky: 'Bluesky',
    other: 'Otro'
  },

  // Autenticación
  auth: {
    title: 'Bienvenido de nuevo',
    subtitle: 'Inicia sesión en tu cuenta para continuar',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'nombre@ejemplo.com',
    passwordLabel: 'Contraseña',
    signInButton: 'Iniciar sesión',
    signingIn: 'Iniciando sesión...',
    errorInvalid: 'Correo electrónico o contraseña inválidos',
    loginErrorTitle: 'Error de inicio de sesión',
    loginErrorDescription: 'Verifica tus credenciales e inténtalo de nuevo.',
    forgotPassword: '¿Olvidaste tu contraseña?',
    heroTitle: 'Domina tu vigilancia estratégica con IA.',
    heroSubtitle: 'Automatiza la recopilación, el análisis y la difusión de tu información estratégica con nuestra plataforma inteligente.',
    features: [
      'Vigilancia multi-fuente en tiempo real',
      'Análisis semántico avanzado',
      'Generación automatizada de boletines',
      'Paneles personalizables'
    ],
    copyright: 'Raiso. Todos los derechos reservados.',
    sessionExpiredTitle: 'Sesión expirada',
    sessionExpiredDescription: 'Tu sesión ha expirado. Por favor, inicia sesión de nuevo para continuar.',
    accountDeactivatedTitle: 'Acceso revocado',
    accountDeactivatedDescription: 'Tu cuenta ha sido desactivada o tu acceso a este espacio fue revocado. Contacta con la agencia que te invitó.',
    switchToSignup: '¿No tienes una cuenta?',
    switchToSignupLink: 'Crear una cuenta',
    switchToLogin: '¿Ya tienes una cuenta?',
    switchToLoginLink: 'Iniciar sesión',
    signupTitle: 'Crea tu cuenta',
    signupSubtitle: 'Elige tu plan y comienza ahora',
    fullNameLabel: 'Nombre completo',
    fullNamePlaceholder: 'Juan García',
    nextButton: 'Continuar',
    backButton: 'Volver',
    stepAccount: 'Cuenta',
    stepPlan: 'Plan',
    stepPayment: 'Pago',
    selectPlan: 'Elegir este plan',
    selectedPlan: 'Plan seleccionado',
    perMonth: '/mes',
    perYear: '/año',
    billingMonthly: 'Mensual',
    billingAnnual: 'Anual',
    annualSavePercent: 'Ahorra {percent}%',
    individualPlansTitle: 'Planes individuales',
    agencyPlansTitle: 'Planes de agencia',
    agencyIncludedSeats: '{n} asiento(s) incluido(s)',
    agencyExtraSeat: '{price}€/asiento extra',
    promoCodeLabel: 'Código promocional (opcional)',
    promoCodePlaceholder: 'Ingresa tu código promocional',
    promoCodeApply: 'Aplicar',
    promoCodeValid: '¡Código promocional aplicado!',
    promoCodeInvalid: 'Código promocional inválido o expirado',
    promoCodeChecking: 'Verificando...',
    originalPrice: 'Precio original',
    discount: 'Descuento',
    totalToPay: 'Total a pagar',
    afterDiscount: 'después del descuento',
    vatLabel: 'IVA (20%)',
    freeAccess: '¡Acceso gratuito gracias al código promocional!',
    createAccountButton: 'Crear mi cuenta',
    createAccountAndPay: 'Crear mi cuenta y pagar',
    redirectingToStripe: 'Redirigiendo al pago...',
    signupSuccess: '¡Cuenta creada con éxito!',
    signupWelcome: '¡Bienvenido! Su pago ha sido confirmado, su cuenta está lista.',
    signupPaymentCancelled: 'Pago cancelado. Podrá finalizar su suscripción más tarde.',
    signupError: 'Error al crear la cuenta',
    emailAlreadyExists: 'Ya existe una cuenta con esta dirección de correo electrónico',
    passwordRuleMinLength: '8 caracteres mínimo',
    passwordRuleUppercase: 'Una mayúscula (A-Z)',
    passwordRuleDigit: 'Un dígito (0-9)',
    passwordRuleSpecial: 'Un carácter especial (!@#...)',
    confirmPasswordLabel: 'Confirmar contraseña',
    passwordsMismatch: 'Las contraseñas no coinciden.',
    passwordsMatch: 'Contraseñas coinciden',
    passwordSecurityError: 'La contraseña no cumple con los requisitos de seguridad.',
    loadPlansError: 'Error al cargar los planes',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordCopied: 'Contraseña copiada',
    passwordSaveReminder: '⚠️ ¡Anota tu contraseña en algún lugar antes de continuar!',
    creditsPerMonth: 'créditos/mes',
    watermark: 'Marca de agua',
    referralCodeLabel: 'Código de referido (opcional)',
    referralCodePlaceholder: 'Código de referido',
    // Pricing cards
    htLabel: 'sin IVA',
    ttcLabel: 'con IVA',
    vatAtCheckout: 'IVA calculado al pagar',
    monthShort: 'mes',
    billedAnnually: 'facturado anualmente',
    freePrice: 'Gratis',
    mostPopular: 'EL MÁS POPULAR',
    perExtraClient: '/ cliente adicional',
    // Plan taglines
    taglineFree: 'Descubre RAISO gratis',
    taglinePro: 'Todo lo que necesita un creador independiente',
    taglineAgency: 'Gestiona todos tus clientes desde un solo lugar',
    // Plan CTAs
    ctaFree: 'Comenzar gratis',
    ctaPro: 'Comenzar Pro',
    ctaAgency: 'Comenzar Agency',
    // Free plan features
    featureFree1: '1 usuario',
    featureFree2: '1 red social conectada',
    featureFree3: 'Número limitado de publicaciones generadas',
    featureFree4: 'Mención «vía Raiso» en tus publicaciones',
    featureFree5: 'Solo funcionalidades esenciales',
    // Pro plan features
    featurePro1: '1 marca / espacio de trabajo',
    featurePro2: 'Todas tus redes sociales conectadas',
    featurePro3: 'Seguimiento ilimitado de tus temas y fuentes de actualidad',
    featurePro4: 'Publicaciones generadas sin límite',
    featurePro5: 'Calendario de publicaciones',
    featurePro6: 'Programación y publicación automáticas',
    featurePro7: 'Estadísticas de rendimiento detalladas',
    // Agency plan features
    featureAgency1: '10 subcuentas de clientes',
    featureAgency2: 'Multi-marca',
    featureAgency3: 'Dashboard de agencia centralizado',
    featureAgency4: 'Gestión de accesos',
    featureAgency5: 'Analíticas por cliente',
    featureAgency6: 'Planificación multi-cuenta',
    // Email verification
    verifyEmailTitle: 'Verifica tu email',
    verifyEmailDescription: 'Se ha enviado un email de verificación a {email}. Haz clic en el enlace para activar tu cuenta.',
    resendVerificationEmail: 'Reenviar email de verificación',
    checkSpamFolder: 'Si no encuentras el email, recuerda revisar tu carpeta de spam o correo no deseado.',
    verificationEmailResent: '¡Email de verificación reenviado!',
    verificationEmailResendError: 'Error al enviar el email',
    emailVerifiedSuccess: '¡Email verificado con éxito! Ya puedes iniciar sesión.',
    emailVerifiedWelcome: '¡Email verificado con éxito!',
    emailVerificationExpired: 'El enlace de verificación ha expirado. Por favor, solicita uno nuevo.',
    emailVerificationInvalid: 'El enlace de verificación es inválido.',
    emailNotVerifiedError: 'Tu email aún no está verificado. Revisa tu bandeja de entrada.',
    // Forgot / reset password
    forgotPasswordTitle: '¿Olvidaste tu contraseña?',
    forgotPasswordSubtitle: 'Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.',
    forgotPasswordSubmit: 'Enviar enlace',
    forgotPasswordSubmitting: 'Enviando...',
    forgotPasswordEmailSent: 'Si esta dirección está asociada a una cuenta, recibirás un email en unos minutos.',
    checkSpamWarning: 'Revisa tu carpeta de spam si no recibes nada.',
    forgotPasswordBackToLogin: 'Volver al inicio de sesión',
    resetPasswordTitle: 'Nueva contraseña',
    resetPasswordSubtitle: 'Elige una nueva contraseña para tu cuenta.',
    resetPasswordSubmit: 'Restablecer contraseña',
    resetPasswordSubmitting: 'Restableciendo...',
    resetPasswordSuccess: '¡Contraseña restablecida! Ya puedes iniciar sesión.',
    resetPasswordExpired: 'Este enlace ha expirado o es inválido. Solicita uno nuevo.',
    resetPasswordInvalid: 'Este enlace no es válido.',
    resetPasswordError: 'Se produjo un error. Por favor, inténtelo de nuevo.',
    requestNewLink: 'Solicitar un nuevo enlace',
    newPasswordLabel: 'Nueva contraseña',
    confirmNewPasswordLabel: 'Confirmar nueva contraseña',
  },

  // Configuración general
  settings: {
    title: 'Configuración general',
    setupScore: 'Puntuación de configuración',
    setupScoreLabel: 'Puntuación de configuración',
    setupAnalyze: 'Analizar mi configuración',
    setupCheckPositioning: 'Posicionamiento definido',
    setupCheckSources: 'Al menos 1 fuente agregada',
    setupCheckChannels: 'Al menos 1 canal creado',
    // V4-WATCH-KEYWORDS-i18n 2026-05-29 — vocabulario "Vigilancia".
    setupCheckTopics: 'Al menos 1 temática (palabras clave cortas)',
    setupCheckMultipleSources: '3 fuentes o más',
    setupCheckConnectedChannel: '1 canal conectado (Zernio)',
    language: 'Idioma de la interfaz',
    languageLabel: 'Idioma',
    typography: 'Tipografía',
    typographyPlaceholder: 'Elegir una fuente',
    typographyPreview: 'Vista previa de tipografía - Texto de muestra',
    colorScheme: 'Paleta de colores',
    saveColors: 'Guardar colores',
    resetColors: 'Restablecer',
    logo: 'Logo de la empresa',
    logoUrl: 'URL del logo',
    logoUrlPlaceholder: 'https://...',
    saveLogo: 'Guardar logo',
    uploadLogo: 'Subir un archivo',
    chooseFile: 'Elegir un archivo',
    uploading: 'Subiendo...',
    orUseUrl: 'o usar una URL',
    logoUploaded: 'Logo subido con éxito',
    logoUploadError: 'Error al subir el logo',
    invalidLogoType: 'Tipo de archivo no soportado (JPEG, PNG, GIF, WebP, SVG)',
    logoTooLarge: 'El archivo es demasiado grande (máx 5MB)',
    // V4-SETTINGS-01 2026-05-29 — Tooltip secciones marca bloqueadas
    brandLockedTooltip: 'Configure su posicionamiento para desbloquear esta sección.',
    locked: 'Bloqueado',
    // V4-FRONT-WIZARD-POST-GEN-HIDE 2026-05-29 — Toggle tutorial de onboarding
    onboardingToggleLabel: 'Mostrar el tutorial de onboarding',
    onboardingToggleDescription: 'Volver a mostrar la guía de 4 pasos (Posicionamiento, Temáticas, Fuentes, Canales) sobre la galería de publicaciones.',
  },

  // Personalización
  customization: {
    colorPickerDescription: 'Seleccionar un color personalizado',
  },

  // Fuentes
  sources: {
    freePlan: 'Plan Free',
    upgradeToReactivate: 'Pasa a Pro para reactivar esta fuente',
    title: 'Fuentes',
    titleTooltip: 'Las fuentes son los flujos que Raiso supervisa (RSS, sitios web, canales de YouTube) para alimentar tu vigilancia y generar contenido basado en la actualidad de tus temáticas.',
    add: 'Crear tu primera fuente',
    suggestButton: 'Generar fuentes',
    suggestTitle: 'Sugerir fuentes de monitoreo',
    suggestDescription: 'Según tu posicionamiento y tus temáticas, aquí hay fuentes que te proponemos. Desmarca las que no te interesen.',
    suggestLoading: 'Generando…',
    suggestEmpty: 'No hay sugerencias disponibles.',
    suggestError: 'No se pueden generar sugerencias de fuentes.',
    suggestErrorAdd: 'Error al añadir fuentes',
    suggestSuccess: '{count} fuente(s) añadida(s)',
    suggestAdding: 'Añadiendo {count} fuente(s)…',
    emptyTitle: 'Ninguna fuente',
    emptyDescription: 'Agrega feeds RSS, sitios web o canales YouTube para alimentar tu vigilancia. La IA puede sugerir algunos.',
    suggestNoTopics: 'Añade primero una temática para activar las sugerencias IA',
    none: 'Ninguna fuente configurada',
    name: 'Nombre de la fuente',
    url: 'URL',
    type: 'Tipo',
    keywords: 'Palabras clave',
    keywordsPlaceholder: 'Separa las palabras clave con comas',
    enabled: 'Activado',
    lastSync: 'Última sincronización',
    suggestedSources: 'Fuentes sugeridas',
    suggestedSourcesDescription: 'Fuentes extraídas automáticamente de tus temáticas',
    acceptSuggestion: 'Aceptar',
    rejectSuggestion: 'Rechazar',
    deleteSuggestion: 'Eliminar esta sugerencia',
    newSource: 'Nueva fuente',
    newKeyword: 'Nueva palabra clave',
    exampleName: 'Ej., TechCrunch',
    validateSource: 'Validar esta fuente',
    deleteSuggestionTitle: 'Eliminar esta sugerencia',
    previewSource: 'Vista previa de esta fuente',
    tutorialTitle: 'Tutorial de Youtube',
    tutorialDescription: 'Aprende a agregar fuentes desde videos de Youtube.',
    deleteSourceTitle: '¿Eliminar esta fuente?',
    deleteSourceDescription: '¿Estás seguro de que quieres eliminar "{title}"? Esta acción es irreversible.',
    recommend: 'Recomendar',
    recommendedSources: 'Fuentes recomendadas',
    defineInterestsFirst: 'Por favor define primero tus temáticas',
    examplesDescription: 'Estas fuentes son ejemplos para inspirarte. Haz clic en ✓ para agregarlas o en la papelera para ignorarlas.',
    examplesNote: '💡 Estas sugerencias son ejemplos basados en tus temáticas. Personalízalas según tus necesidades.',
    youtubeIdHelp: 'El ID del canal de YouTube comienza con "UC" seguido de 22 caracteres. Puedes encontrarlo en la URL del canal o en el código fuente de la página.',
    youtubeIdInvalid: 'Formato de ID de YouTube inválido. El ID debe comenzar con "UC" seguido de 22 caracteres alfanuméricos.',
    urlInvalid: 'Formato de URL inválido. La dirección debe comenzar por http:// o https://.',
    validatingSource: 'Verificando la fuente...',
    sourceValidationFailed: 'No se puede acceder a esta fuente. Verifica la URL o el ID.',
    sourceValidationSuccess: '¡Fuente accesible!',
    refreshSource: 'Actualizar la fuente',
    syncAll: 'Sincronizar todo',
    // Trazabilidad de fuentes multi-agente
    usedForGeneration: 'Fuentes utilizadas para la generación',
    relevance: 'Relevancia',
    sourceDetails: 'Detalles de la fuente',
    keyFacts: 'Hechos clave extraídos',
    relevanceHigh: 'Alta',
    relevanceMedium: 'Media',
    relevanceLow: 'Baja',
    relevanceTooltip: 'Correspondencia estimada entre este artículo y tu posicionamiento + tus intereses. Cuanto mayor sea la puntuación, más se ajusta el artículo a tu línea editorial.',
    staleWarning: '{count} fuente(s) no sincronizada(s) desde hace más de 7 días',
    syncProgress: 'Sincronización en curso ({count})',
    aiSummary: 'Resumen IA',
    postAngles: 'Ángulos editoriales',
    entities: 'Entidades mencionadas',
    extractedKeywords: 'Palabras clave extraídas',
    feedItems: 'Elementos recopilados',
    feedItemsDescription: 'Lista de elementos recopilados para esta fuente',
    // V4-FEEDITEMS-FILTERS-REDESIGN 2026-07-30 — libellés des filtres (étaient en dur)
    filterScore: 'Puntuación',
    filterDate: 'Desde…',
    filterMinScore: 'Puntuación mínima',
    filterAnyScore: 'Todas',
    resetFilters: 'Restablecer todo',
    viewItems: 'Consultar',
    noItems: 'Ningún elemento encontrado',
    itemCountTooltip: '{count} elemento(s) recopilado(s)',
    // V4-SOURCE-ERROR-NO-DIAGNOSTIC — estados de sincronización (estaban en inglés fijo)
    syncStatusPending: 'Sincronizando…',
    syncStatusSuccess: 'Sincronizada',
    syncStatusFailed: 'Error',
    // Mensajes accionables por código (véase src/utils/sourceSyncError.ts)
    syncErrorEmptyContent: 'La fuente respondió, pero sin contenido utilizable: página vacía, protección anti-bot o transcripción no disponible. Abre la URL en un navegador para comprobar que muestra texto.',
    syncErrorChannelNotFound: 'Canal de YouTube no encontrado: fue eliminado o pasó a privado. La fuente se ha desactivado automáticamente.',
    syncErrorUrlNotAllowed: 'Esta URL fue rechazada por motivos de seguridad (dirección interna, protocolo no permitido o dominio bloqueado). Usa una URL pública en http(s).',
    syncErrorUnknown: 'La última sincronización falló por un motivo inesperado. Vuelve a intentarlo; si persiste, envía el detalle técnico al soporte.',
    syncErrorDetail: 'Detalle técnico',
    syncErrorRetryHint: 'Usa el botón de sincronización para volver a intentarlo.',
    aiAnalyzed: 'Analizado por IA',
    qualityScore: 'Puntuación de calidad',
    keyPoints: 'Puntos clave',
    viewpoints: 'Puntos de vista',
    confidence: 'confianza',
    targetAudience: 'Objetivo',
    sourceContext: 'Fuente',
    risksGuardrails: 'Riesgos y salvaguardas',
    maxReached: 'Límite de fuentes alcanzado. Actualice a un plan superior.',
    // V4-SOURCES-I18N-LABELS 2026-05-29 — FINDING-SOURCES-01
    rssFeedUrl: 'URL del flujo RSS',
    youtubeChannelId: 'ID del canal (canónico)',
    podcastUrl: 'URL del podcast',
    rawTextLabel: 'Contenido',
    urlLabel: 'URL',
    // V4-SOURCES-CTA-CREATE 2026-05-29 — FINDING-CHANNELS-01
    createCTA: 'Crear',
    types: {
      RSS: 'RSS',
      API: 'API',
      'Web Scraper': 'Web Scraper',
      Manuel: 'Manual',
    },
  },

  // Vigilancia
  watch: {
    // V4-FRONT-NAMING-WIZARD-VEILLE 2026-06-03 — vocabulario "Intereses" (revert de V4-NAMING-VEILLE).
    title: 'Temáticas',
    add: 'Nueva temática',
    none: 'Ninguna temática configurada. Crea tu primera temática para comenzar.',
    suggestButton: 'Generar palabras clave',
    suggestTitle: 'Sugerir temáticas',
    suggestDescription: 'Según tu posicionamiento, aquí hay temáticas que te proponemos monitorear. Desmarca las que no te interesen.',
    suggestLoading: 'Generando…',
    suggestEmpty: 'No hay sugerencias disponibles.',
    suggestError: 'No se pueden generar sugerencias. Verifica tu posicionamiento.',
    suggestErrorAdd: 'Error al añadir temáticas',
    suggestSuccess: '{count} temática(s) añadida(s)',
    suggestAdding: 'Añadiendo {count} temática(s)…',
    emptyTitle: 'Ninguna temática',
    emptyDescription: 'Empieza describiendo los temas que quieres monitorear. La IA puede sugerir algunos según tu posicionamiento.',
    // Nuevos campos título/descripción
    topicTitle: 'Título',
    topicTitlePlaceholder: 'Ej: Vigilancia Inteligencia Artificial',
    topicTitleTooltip: 'Un título corto y descriptivo para identificar fácilmente esta temática.',
    description: 'Descripción',
    descriptionPlaceholder: 'Ej: Seguir las últimas noticias sobre IA generativa, LLMs y sus aplicaciones empresariales.',
    descriptionTooltip: 'Describe en detalle lo que deseas monitorear. Esta descripción ayuda a la IA a encontrar contenido relevante.',
    // Campos antiguos conservados para compatibilidad
    prompt: 'Descripción',
    promptPlaceholder: 'Ej: Seguir las últimas noticias sobre IA generativa y LLMs...',
    keywords: 'Palabras clave',
    keywordsPlaceholder: 'Ej: ChatGPT, Claude, LLM, IA generativa',
    keywordsTooltip: 'Agrega palabras clave específicas para refinar la vigilancia. Estos términos se usarán para filtrar y priorizar el contenido.',
    enabled: 'Activado',
    createdDate: 'Fecha de creación',
    deleteTitle: '¿Eliminar esta temática?',
    deleteDescription: 'Esta acción es irreversible. La temática y sus palabras clave se eliminarán permanentemente.',
    newKeyword: 'Nueva palabra clave',
    generatingKeywords: 'Generando palabras clave con IA...',
    keywordsGenerated: '💡 Las palabras clave se generan automáticamente por IA al crear',
    keywordWarningChars: 'Evita comas y puntos — usa palabras simples',
    keywordsGenerating: 'Generando palabras clave…',
    generateViaAI: 'Generar palabras clave',
    webSearchItems: 'Resultados de búsqueda web',
    webSearchItemsTooltip: '{count} resultado(s) web recopilado(s) durante la generación',
    viewItems: 'Consultar',
    noItems: 'Ningún resultado web encontrado',
  },

  // Posicionamiento
  positioning: {
    title: 'Posicionamiento general',
    description: 'Define tu posicionamiento global',
    prompt: 'Prompt del sistema',
    promptPlaceholder: 'Describe tu posicionamiento, tono, valores...',
    improve: 'Mejorar',
    save: 'Guardar',
    modeChat: 'Agente',
    modeText: 'Texto',
    modeBrandConfig: 'Identidad de marca',
    modeBrandConfigShort: 'Marca',
    modeToggleLabel: 'Modo',
    chatPlaceholder: 'Escribe tu respuesta...',
    // Chat conversation messages
    chatInitialMessage: 'Hola, voy a acompañarte en la formulación de tu posicionamiento para ayudar a nuestros agentes a generar contenido realmente personalizado. Para empezar, ¿puedes decirme si usas este servicio a título personal o en nombre de una empresa?',
    chatInitialMessageExisting: '¡Hola! Tu posicionamiento ya está configurado. Puedo mejorarlo, refinarlo o enriquecerlo. ¿Qué te gustaría cambiar?',
    chatQuestionPersonal: '¡Genial! ¿Y cuál es tu dominio de actividad o interés principal?',
    chatQuestionCompany: '¡Perfecto! ¿Cuál es el nombre de tu empresa y en qué sector opera?',
    chatQuestionTone: '¡Interesante! Ahora, ¿cómo describirías el tono que deseas para tu contenido? ¿Más bien formal y profesional, o relajado y accesible?',
    chatQuestionValues: '¡Excelente elección! ¿Puedes darme 3 valores o mensajes clave que deseas transmitir en tus contenidos?',
    chatQuestionAudience: '¡Perfecto! Última pregunta: ¿quién es tu audiencia objetivo? Descríbeme el perfil típico de tus lectores.',
    chatFinalMessage: '¡Gracias por toda esta información! Ahora voy a generar un posicionamiento personalizado basado en tus respuestas. Siempre podrás modificarlo desde el modo texto en la parte superior derecha de esta página.',
    chatTypePersonal: 'Personal',
    chatTypeCompany: 'Empresa',
    // New features
    importFromUrl: 'Importar desde URL',
    extracting: 'Extrayendo...',
    extract: 'Extraer',
    extractedInfo: 'Información extraída',
    analyzeStyle: 'Analizar estilo',
    analyzeStyleButton: 'Analizar el estilo',
    analyzing: 'Analizando...',
    styleAnalysis: 'Análisis de estilo',
    pastePostsHere: 'Pega tus posts de ejemplo aquí, separados por ----',
    suggestChanges: 'Solicitar una modificación...',
    suggesting: 'Sugiriendo...',
    accept: 'Aceptar',
    reject: 'Rechazar',
    modify: 'Modificar',
    history: 'Historial',
    historyTitle: 'Historial de versiones',
    sendMessage: 'Enviar mensaje',
    versions: 'Versiones',
    noVersions: 'Sin versiones anteriores',
    restore: 'Restaurar',
    templateInfo: 'Esta es una plantilla por defecto. Completa los campos [entre corchetes] y marca las opciones.',
    clickToEdit: 'Haz clic para editar el texto',
    changesApplied: 'Cambios aplicados',
    versionRestored: 'Versión restaurada',
    // Toolbar buttons
    importUrl: 'Importar URL',
    reset: 'Restablecer',
    // Reset dialog
    resetTitle: 'Restablecer posicionamiento',
    resetConfirm: '¿Estás seguro de querer restablecer tu posicionamiento a la plantilla por defecto?',
    warning: 'Atención',
    resetWarning: 'Si no personalizas la plantilla después de esta acción, la calidad de los próximos posts generados se reducirá significativamente.',
    resetNote: 'Tu posicionamiento actual se guardará en el historial de versiones.',
    // AI suggestion
    aiSuggestionPlaceholder: 'Solicitar una modificación a la IA...',
    // Chat mode info
    chatModeInfo: 'Modo consulta — Habla sobre tu posicionamiento sin modificar la plantilla. Para aplicar cambios, cambia al modo Texto.',
    chatModeSubtitle: 'Haz tus preguntas o pide consejos. Este chat es consultivo.',
    // Apply from chat
    applyThisPositioning: 'Aplicar este posicionamiento',
    positioningApplied: 'Posicionamiento aplicado con éxito',
    applyError: 'Error al aplicar el posicionamiento',
    // Apply suggestion with diff
    applySuggestion: 'Aplicar estas modificaciones',
    discardSuggestion: 'Continuar sin aplicar',
    suggestionReady: 'Modificaciones listas - revisa y confirma',
    noSuggestion: 'Ninguna modificación sugerida',
    suggestionError: 'Error al generar las modificaciones',
    generatingChanges: 'Generando...',
    // DiffView
    accepted: 'aceptados',
    unifiedView: 'Unificado',
    splitView: 'Lado a lado',
    clickToReview: 'Haz clic en ✓ o ✗ para cada línea',
    beforeLabel: 'Antes',
    expectedResult: 'Resultado (esperado)',
  },

  // Setup Wizard
  // V4-UX-SETUP-EXPRESS 2026-07-02 (Phase 1.1) — Onboarding exprés desde la URL.
  setupExpress: {
    title: 'Configura Raiso en 2 minutos',
    subtitle: 'Danos la dirección de tu sitio web: analizamos tu actividad y luego preparamos automáticamente tus temas de vigilancia y tus fuentes.',
    subtitlePositioningDone: 'Tu posicionamiento está listo. Preparamos automáticamente tus temas de vigilancia y tus fuentes.',
    agencyContext: 'Configuración del espacio «{spaceName}».',
    urlLabel: 'Dirección de tu sitio web',
    urlPlaceholder: 'https://mi-empresa.com',
    urlInvalid: 'La dirección de tu sitio parece inválida. Verifícala o configúralo manualmente.',
    // V4-ONBOARDING-PERSONAL-BRANDING
    sourceModeWebsite: 'Tengo un sitio web',
    sourceModePersonal: 'Marca personal',
    personalPostsLabel: 'Pega de 3 a 5 de tus publicaciones',
    personalPostsPlaceholder: 'Pega aquí tus publicaciones, separadas por una línea en blanco entre cada una…',
    personalPostsHint: 'Analizamos tu estilo y tus temas para construir tu posicionamiento.',
    postsInvalid: 'Pega al menos 2 publicaciones, separadas por una línea en blanco.',
    sectorWatchLabel: 'Me apoyo en la actualidad de mi sector',
    sectorWatchHint: 'Si se activa, creamos temas de vigilancia y fuentes. Si no, nos basamos únicamente en tu estilo.',
    stateNotNeeded: 'No necesario para tu perfil',
    importPostsCta: 'Importar mis últimas publicaciones',
    importPostsDone: '{count} publicaciones importadas.',
    importPostsEmpty: 'No hay publicaciones para importar. Pega tus publicaciones manualmente.',
    start: 'Configurar automáticamente',
    manualLink: 'Prefiero configurarlo manualmente',
    runningTitle: 'Preparando tu espacio…',
    runningSubtitle: 'Tarda menos de un minuto.',
    stepPositioning: 'Análisis de tu actividad',
    stepTopics: 'Temas de vigilancia',
    stepSources: 'Fuentes de contenido',
    stateRunning: 'En curso…',
    stateDone: 'Hecho',
    stateSkipped: 'Ya configurado',
    stateFailed: 'Por completar manualmente',
    topicsCreated: '{count} temas añadidos',
    sourcesCreated: '{count} fuentes añadidas',
    extractFailedTitle: 'No pudimos analizar tu sitio web',
    extractFailedDesc: 'Puede que el sitio esté protegido o sea demasiado lento. Configuremos tu posicionamiento juntos, paso a paso.',
    goManual: 'Configuración guiada',
    retry: 'Intentar con otra dirección',
    doneTitle: '¡Tu espacio está listo!',
    doneSubtitle: 'Último paso: conecta una red social para generar y publicar tus primeras publicaciones.',
    doneSubtitleChannel: 'Puedes generar tus primeras publicaciones ahora mismo.',
    doneSubtitleNoChannel: 'Conecta una red social para generar y luego publicar tus publicaciones.',
    ctaGenerate: 'Generar mis primeras publicaciones',
    ctaConnectChannel: 'Conectar una red social',
    noChannelWarning: 'No podrás publicar hasta que conectes una red a tu cuenta.',
    reviewSetup: 'Ver / ajustar mi configuración',
    incompleteTitle: 'Configuración incompleta',
    incompleteDesc: 'Algunos pasos no se completaron. Vuelve a lanzar la configuración automática o complétalos manualmente.',
    retryAuto: 'Relanzar la configuración automática',
    addTopicsManually: 'Añadir mis temas manualmente',
    addSourcesManually: 'Añadir mis fuentes manualmente',
  },
  setupWizard: {
    title: '¡Bienvenido a Raiso!',
    subtitle: 'Para obtener publicaciones de calidad, Raiso necesita un poco de contexto. Configura estos 4 elementos esenciales para empezar:',
    progressLabel: '{completed}/{total} pasos completados',
    stepPositioning: 'Posicionamiento',
    stepPositioningDesc: 'Define tu identidad, tu tono y tu público objetivo.',
    stepWatch: 'Temáticas',
    stepWatchDesc: 'Indica las temáticas sobre las que deseas comunicar.',
    stepSources: 'Fuentes',
    stepSourcesDesc: 'Añade feeds RSS, sitios web o canales de YouTube para monitorizar.',
    stepChannels: 'Canales',
    stepChannelsDesc: 'Configura al menos un canal de comunicación (ej: LinkedIn, X).',
    buttonConfigure: 'Configurar',
    buttonCompleted: 'Completado',
    completedTitle: '¡Todo listo! 🎉',
    completedSubtitle: 'Tu espacio de trabajo está configurado. Ahora puedes generar tus primeros posts.',
    buttonStart: 'Empezar a generar',
    // Backlog UX 19-05 — bloqueo secuencial de pasos
    lockedStepBadge: 'Bloqueado',
    lockedStepTooltip: 'Completa primero el paso "{previousTitle}" para desbloquear este.',
    lockedStepDescription: 'Disponible después del paso anterior.',
    // V4-5 — CTA identidad visual al final del asistente
    brandConfigCtaTitle: '🎨 Tus colores y fuentes, para carruseles e imágenes coherentes',
    brandConfigCtaDesc: 'Define tu paleta, fuentes y logo: tus carruseles e imágenes generados por la IA los reutilizan automáticamente para mantenerse fieles a tu marca. Extraídos de tu sitio o introducidos manualmente. Es opcional — ya puedes generar posts sin ella.',
    brandConfigCtaButton: 'Configurar',
    // V4-WIZARD-02 2026-05-29 — CTA fin del asistente
    startCTA: 'Empezar a generar publicaciones',
    // V4-WIZARD-AGENCY-CONTEXT 2026-06-18 — banner en la cabecera del asistente para
    // cuentas de agencia: aclara DE QUIÉN se configura el posicionamiento (espacio = un cliente).
    agencyContextTitle: '👥 Espacio del cliente',
    agencyContextDesc: 'Estás configurando el espacio «{spaceName}». El posicionamiento, las temáticas y las fuentes a continuación se aplican a este cliente.',
  },

  // V4-ONBOARDING-TOUR 2026-06-18 — burbujas explicativas del tour de producto (react-joyride).
  tour: {
    // Botones de navegación
    back: 'Anterior',
    close: 'Cerrar',
    last: 'Finalizar',
    next: 'Siguiente',
    skip: 'Omitir',
    // Pasos (recorrido agencia)
    spaceSwitcherTitle: 'Tus espacios de cliente',
    spaceSwitcherDesc: 'Cada espacio corresponde a uno de tus clientes. Cambia de espacio aquí para configurar y publicar para el cliente adecuado.',
    spacesManageTitle: 'Gestiona tus espacios',
    spacesManageDesc: 'Crea, renombra o archiva tus espacios aquí, e invita a tus clientes en solo lectura.',
    // Pasos comunes
    positioningTitle: 'Posicionamiento',
    positioningDesc: 'Define tu identidad, tu tono y tu público. Es la base de todo lo que Raiso genera.',
    watchTitle: 'Temáticas',
    watchDesc: 'Indica las temáticas sobre las que deseas comunicar: Raiso vigila la actualidad relacionada.',
    sourcesTitle: 'Fuentes',
    sourcesDesc: 'Añade feeds RSS, sitios o canales de YouTube: Raiso se inspira en ellos para generar posts relevantes.',
    channelsTitle: 'Canales',
    channelsDesc: 'Conecta tus redes (LinkedIn, X, Instagram…) para publicar directamente desde Raiso.',
    engagementTitle: 'Interacción',
    engagementDesc: 'Encuentra aquí los comentarios recibidos en tus publicaciones para responderlos.',
    generateTitle: 'Generar posts',
    generateDesc: 'Cuando tu configuración esté lista, inicia la generación de posts aquí. Podrás revisarlos, editarlos y publicarlos.',
  },

  // Onboarding - Flujo de preguntas guiadas
  onboarding: {
    // Tooltips secuenciales (chantier C 2026-05)
    lockedTooltip: "Completa primero este paso para continuar",
    // V4-NAMING-VEILLE 2026-05-29
    lockedTopicsTooltip: "Define primero tu posicionamiento para desbloquear la vigilancia",
    // V4-WATCH-KEYWORDS-i18n 2026-05-29 — vocabulario "Vigilancia".
    lockedSourcesTooltip: "Añade al menos una temática para desbloquear las fuentes",
    lockedChannelsTooltip: "Añade al menos una fuente para desbloquear los canales de comunicación",
    lockedPostsTooltip: "Conecta al menos un canal para desbloquear la galería de publicaciones",
    lockedAnalyticsTooltip: "Genera tu primer post para desbloquear las analíticas",
    lockedEngagementTooltip: "Genera tu primer post para desbloquear la interacción (comentarios)",
    lockedPublicationsTooltip: "Genera tu primer post para desbloquear la cola de publicaciones",
    comingSoonTooltip: "Esta funcionalidad estará disponible próximamente",
    readOnlyTooltip: "Estás consultando este espacio en modo solo lectura",
    // Phase 1.4 — widget de progreso global persistente (OnboardingProgressWidget)
    setupProgress: {
      title: "Tu configuración",
      resumePrefix: "Retoma en",
      continueBtn: "Continuar",
      expand: "Mostrar el progreso",
      stepPositioning: "Posicionamiento",
      stepTopics: "Temáticas",
      stepSources: "Fuentes",
      stepChannels: "Canales",
      optional: "opcional",
      reopenAssistant: "Reabrir el asistente",
      dragHint: "Arrastra para mover",
    },
    // Mensajes de los pasos
    steps: {
      welcome: {
        message: "¡Hola! 👋 Soy tu asistente de posicionamiento. Te haré algunas preguntas para crear un perfil personalizado que permitirá a nuestros agentes de IA generar contenido realmente adaptado a tu estilo.\n\n¿Empezamos?",
        startButton: "¡Vamos!",
      },
      usageType: {
        message: "¡Perfecto! Para empezar, ¿usas este servicio a título personal o para una empresa?",
        personal: "👤 A título personal",
        company: "🏢 Para una empresa",
        custom: "✏️ Definir yo mismo",
      },
      companyUrl: {
        message: "¡Genial! Para entender mejor tu empresa, ¿tienes un sitio web? Puedo analizar tu página de inicio o la página \"Sobre nosotros\" para extraer automáticamente la información clave.",
        hasUrl: "🔗 Sí, proporciono la URL",
        noUrl: "✏️ No, lo describo manualmente",
        placeholder: "https://www.miempresa.com",
      },
      companyName: {
        message: "¡Sin problema! ¿Puedes darme el nombre de tu empresa y describir brevemente su actividad?",
        placeholder: "Ej: 3615 Future es una consultora de IA que acompaña a las empresas en su transformación digital.",
      },
      personalDomain: {
        message: "¡Entendido! ¿Cuál es tu área principal de actividad o experiencia? Esto me ayudará a personalizar tu posicionamiento.",
        placeholder: "Ej: Marketing digital, Desarrollo web, Coaching...",
      },
      purpose: {
        message: "¡Muy bien! ¿Cuál es tu objetivo principal en las redes sociales?",
        brandAwareness: "📢 Desarrollar mi notoriedad",
        thoughtLeadership: "💡 Compartir mi experiencia",
        leadGeneration: "🎯 Generar leads",
        community: "🤝 Animar mi comunidad",
        recruitment: "👥 Reclutar / Marca empleadora",
        other: "✨ Otro objetivo",
      },
      tone: {
        message: "¡Excelente! ¿Cómo quieres que se perciba tu contenido? Elige el tono que mejor te represente.",
        professional: "👔 Profesional y experto",
        friendly: "😊 Amigable y accesible",
        inspiring: "✨ Inspirador y motivador",
        provocative: "🔥 Provocador y disruptivo",
        educational: "📚 Pedagógico e informativo",
        humorous: "😄 Humorístico y ligero",
        custom: "✏️ Definir yo mismo",
      },
      values: {
        message: "¡Perfecto! ¿Cuáles son los 3 valores o mensajes clave que quieres transmitir en tu contenido?\n\nPuedes separarlos con comas.",
        placeholder: "Ej: Innovación, Autenticidad, Excelencia al cliente",
      },
      audience: {
        message: "¡Última pregunta! ¿Quién es tu audiencia objetivo? Descríbeme el perfil típico de las personas que quieres alcanzar.",
        placeholder: "Ej: Directores de PYMES tech, 35-55 años, interesados en innovación y transformación digital",
      },
      summary: {
        message: "¡Gracias por toda esta información! 🎉\n\nEsto es lo que entendí:\n{summary}\n\nAhora generaré tu posicionamiento personalizado. Siempre podrás modificarlo después desde el modo texto en la parte superior derecha de esta página.",
        confirm: "Generar mi posicionamiento",
        restart: "Empezar de nuevo",
      },
      complete: {
        message: "✅ ¡Tu posicionamiento se ha generado con éxito!\n\nPuedes verlo y editarlo desde el modo texto en la parte superior derecha de esta página. Nuestros agentes de IA ahora usarán esta información para crear contenido personalizado.",
      },
    },
    // Etiquetas del resumen
    summaryLabels: {
      usage: "Uso",
      usagePersonal: "Personal",
      usageCompany: "Empresa",
      company: "Empresa",
      domain: "Dominio",
      companyDetected: "Empresa (detectada)",
      sector: "Sector",
      purpose: "Objetivo",
      tone: "Tono",
      values: "Valores",
      audience: "Audiencia",
    },
    // Etiquetas de objetivos
    purposeLabels: {
      brand_awareness: "Desarrollar mi notoriedad",
      thought_leadership: "Compartir mi experiencia",
      lead_generation: "Generar leads",
      community: "Animar mi comunidad",
      recruitment: "Reclutar / Marca empleadora",
      other: "Otro",
    },
    // Etiquetas de tono
    toneLabels: {
      professional: "Profesional y experto",
      friendly: "Amigable y accesible",
      inspiring: "Inspirador y motivador",
      provocative: "Provocador y disruptivo",
      educational: "Pedagógico e informativo",
      humorous: "Humorístico y ligero",
    },
    // Lista de progreso
    checklist: {
      progression: "Progreso",
      usageType: "Tipo de uso",
      identityCompany: "Empresa",
      identityPersonal: "Campo de actividad",
      purpose: "Objetivo",
      tone: "Tono",
      values: "Valores",
      audience: "Audiencia",
      personal: "Personal",
      company: "Empresa",
    },
    // Etiquetas cortas para la lista
    checklistShort: {
      brand_awareness: "Notoriedad",
      thought_leadership: "Experiencia",
      lead_generation: "Leads",
      community: "Comunidad",
      recruitment: "Reclutamiento",
      other: "Otro",
      professional: "Pro",
      friendly: "Amigable",
      inspiring: "Inspirador",
      provocative: "Provocador",
      educational: "Pedagógico",
      humorous: "Humorístico",
    },
    // Mensajes de generación
    generating: "✨ Generando tu posicionamiento personalizado...",
    generationSuccess: "✅ ¡Posicionamiento generado con éxito!",
    generationError: "❌ Error al generar el posicionamiento",
    urlAnalyzing: "🔍 Analizando URL...",
    urlSuccess: "✅ ¡Información extraída con éxito!",
    urlError: "❌ No se puede analizar esta URL",
    urlErrorContinue: "⚠️ No pude analizar este sitio. ¡Sin problema, continuemos con la información que me proporciones!",
    urlInvalid: "⚠️ Formato de URL no válido. Por favor, introduzca el nombre y la actividad de su empresa manualmente.",
    restartOnboarding: "Reiniciar asistente",
    describeGoal: "Describe tu objetivo...",
  },

  // Canales de comunicación
  channels: {
    connect: 'Conectar',
    create: 'Crear',
    myAccountPrefix: 'Mi ',
    accountPrefix: 'Cuenta ',
    alreadyConnected: 'ya conectado',
    noPositioning: 'Posicionamiento específico no definido',
    noPositioningTooltip: 'Este canal utilizará el posicionamiento general. Puedes afinar un posicionamiento dedicado a esta red para publicaciones mejor adaptadas.',
    upgradeToReactivate: 'Pasa a Pro para reactivar este canal',
    title: 'Canales de comunicación',
    add: 'Crear tu primer canal',
    none: 'Ningún canal configurado',
    emptyTitle: 'Ningún canal de comunicación',
    emptyDescription: 'Conecta LinkedIn, X, Instagram, Slack u otro canal para publicar tu contenido.',
    customName: 'Nombre del canal',
    customNamePlaceholder: 'Ej: Mi cuenta LinkedIn Pro',
    network: 'Red social',
    messagingPlatform: 'Plataforma de mensajería',
    profileName: 'Nombre del perfil',
    profileNamePlaceholder: 'Ej: @miempresa',
    groupName: 'Nombre del grupo/canal',
    groupNamePlaceholder: 'Ej: Equipo de Marketing',
    profileUrl: 'URL del perfil',
    profileUrlPlaceholder: 'https://...',
    apiKey: 'Clave API (opcional)',
    apiKeyPlaceholder: 'Clave API para automatización',
    webhookUrl: 'URL Webhook (opcional)',
    webhookUrlPlaceholder: 'https://hooks.slack.com/...',
    positioning: 'Posicionamiento específico (opcional)',
    positioningPlaceholder: 'Describe el posicionamiento específico en esta red...',
    dateFrom: 'Fecha de inicio para las fuentes',
    dateFromHelp: 'Las fuentes web se filtrarán desde esta fecha',
    imageProvider: 'Proveedor de generación de imágenes',
    imageProviderHelp: 'Proveedor utilizado para generar imágenes de este canal',
    customNameLabel: 'Nombre personalizado',
    customNameEdit: 'Ej: Mi empresa',
    languages: 'Idiomas de comunicación',
    languagesLabel: 'Idiomas',
    deleteConfirm: '¿Eliminar este canal?',
    deleteDescription: '¿Estás seguro de que deseas eliminar el canal',
    deleteDescriptionFull: 'en {network}? Esta acción es irreversible.',
    deleteAction: 'Esta acción es irreversible.',
    newChannel: 'Nuevo canal',
    channelType: 'Tipo de canal',
    external: 'Externo (Redes sociales)',
    internal: 'Interno (Mensajería)',
    externalChannels: 'CANALES EXTERNOS',
    internalChannels: 'CANALES INTERNOS',
    improveWithAI: 'Mejorar el posicionamiento',
    improvingPositioning: 'Generando...',
    positioningImproved: 'Posicionamiento generado exitosamente',
    profileUrlDisabled: 'Función próximamente disponible',
    apiKeyDisabled: 'Función próximamente disponible',
    oauthDisabled: 'Conexión OAuth próximamente disponible',
    post: 'post',
    posts: 'posts',
    postCountTooltip: '{count} post(s) generado(s) para este canal',
    positioningGlobalRequired: 'Por favor, defina primero un posicionamiento global en la configuración de su espacio.',
    positioningError: 'Error al generar el posicionamiento.',
    automatable: 'Automatizable',
    manualOnly: 'Manual',
    // V4-CHANNELS-MEDIA-CAPABILITIES — formatos de medios publicables vía Zernio por red
    capabilitiesLabel: 'Formatos publicables',
    capImages: 'Imágenes',
    capCarousel: 'Carruseles',
    capVideo: 'Vídeo',
    capGif: 'GIF',
    capNone: 'Solo texto',
    maxReached: 'Límite de canales alcanzado. Actualice a un plan superior.',
    reactivateLimitReached: 'Límite alcanzado — actualice a Pro para reactivar este canal',
    downgradeBanner: 'Algunos canales han sido desactivados tras pasar al Plan Free. Actualice a Pro para reactivarlos todos.',
    // V4-CHANNELS-PENDING-SKELETON 2026-05-29 — FINDING-CHANNELS-02
    creatingChannel: 'Creando el canal…',
  },
  newsletter: {
    title: 'Configuración Newsletter',
    description: 'Personaliza tu newsletter',
    template: 'Plantilla de newsletter',
    templatePlaceholder: 'Describe el formato y estilo de tu newsletter...',
    generate: 'Generar newsletter',
    filterByChannels: 'Filtrar por canales',
    allChannels: 'Todos los canales',
    save: 'Guardar',
    send: 'Enviar',
    sendNewsletter: 'Enviar newsletter',
    selectDate: 'Seleccionar fecha',
    cancel: 'Cancelar',
    validate: 'Validar',
    scheduledFor: 'Programada para',
    addImage: 'Añadir una imagen',
    replaceImage: 'Reemplazar imagen',
    generateImage: 'Generar con IA',
    generatingImage: 'Generando imagen...',
    selectStyle: 'Elegir un estilo',
    imageGenerated: 'Imagen generada con éxito',
    imageGenerationError: 'Error al generar la imagen',
    uploadImage: 'Subir una imagen',
    orGenerateWithAI: 'o generar con IA',
    containsImage: 'Contiene una imagen',
    deleteImage: 'Eliminar imagen',
    edit: 'Editar',
    copy: 'Copiar',
    saved: 'Guardar',
    improveWithAi: 'Mejorar el texto',
    improving: 'Mejorando...',
    improveDialogTitle: 'Mejorar con IA',
    improveDialogDescription: 'Describe cómo quieres mejorar esta publicación',
    improveInstructionsPlaceholder: 'Ej: Hazlo más impactante, añade emojis...',
    improveButton: 'Mejorar',
    improveSuggestions: {
      moreConcise: 'Más conciso',
      moreEngaging: 'Más atractivo',
      addHook: 'Añadir gancho',
      addCTA: 'Añadir llamada a la acción',
      shorterForX: 'Acortar para X (280 car.)',
    },
    // Newsletter modal
    modalTitle: 'Newsletter',
    modalDescription: 'Crear y programar el envío de una newsletter con posts seleccionados',
    introduction: 'Introducción',
    introductionPlaceholder: 'Escribe tu introducción aquí...',
    posts: 'Posts',
    postsCount: 'Posts ({count})',
    dragAndDropPosts: 'Arrastra y suelta posts aquí',
    textMode: 'Modo Texto',
    visualMode: 'Modo Visual',
    preview: 'Vista previa',
    modeConstruction: 'Modo Construcción',
    previewMode: 'Vista previa',
    htmlMode: 'Código HTML',
    enterHtmlCode: 'Introduce tu código HTML...',
    chooseSendDate: 'Elegir fecha de envío',
    settings: 'Configuración',
    generateWithAI: 'Generar con IA',
    addPostsFirst: 'Añade posts primero',
    emailTitle: 'Newsletter - Tu Vigilancia Diaria',
    dailyHeadline: 'Tu Vigilancia Diaria',
    dailySubheadline: 'Las noticias esenciales, directamente en tu buzón',
    copyright: '© 2024 - Todos los derechos reservados',
    footerText: 'Recibes este correo porque estás suscrito a nuestra newsletter',
    unsubscribe: 'Darse de baja',
    defaultIntro: 'Aquí están las últimas noticias y tendencias de la semana...',
    generateFromPosts: 'Generar desde posts',
    generateFromQueue: 'Generar desde cola',
    // Newsletter settings
    settingsTitle: 'Configuración Newsletter',
    settingsDescription: 'Configurar destinatarios y plantilla HTML del newsletter',
    contactsList: 'Lista de contactos (CSV)',
    uploadCSV: 'Subir archivo CSV',
    csvFormatExpected: 'Formato esperado: email, nombre, apellido (opcional)',
    templateHTML: 'Plantilla HTML',
    uploadHTMLTemplate: 'Subir plantilla HTML',
    templateMustContain: 'La plantilla debe contener las etiquetas <div id="introduction"></div> y <div id="posts"></div>',
    currentTemplate: 'Plantilla actual',
    downloadTemplate: 'Descargar plantilla',
    templateDownloaded: 'Plantilla CSV descargada',
    contactsUploaded: '{count} contactos importados con éxito',
    noValidContactsFound: 'No se encontraron contactos válidos en el archivo',
    csvParseError: 'Error al leer el archivo CSV',
    templateUploaded: 'Plantilla HTML importada con éxito',
    templateMissingTags: 'La plantilla debe contener las etiquetas id="introduction" y id="posts"',
    htmlParseError: 'Error al leer el archivo HTML',
  },

  // Automatizaciones
  automations: {
    title: 'Automatizaciones',
    watch: {
      title: 'Temáticas automáticas',
      enabled: 'Activado',
      frequency: 'Frecuencia (días)',
      frequencyDesc: 'Actualizar las temáticas cada {days} días',
      period: 'Período analizado (días)',
      periodDesc: 'Analizar los últimos {period} días (máx: {max})',
      preferredHour: 'Hora de actualización',
      preferredHourDesc: 'Las fuentes se actualizarán automáticamente a las {hour}:00 (UTC)',
    },
    generation: {
      title: 'Generación automática',
      enabled: 'Activado',
      frequency: 'Frecuencia (días)',
      frequencyDesc: 'Generar posts cada {days} días',
      postsCount: 'Número de posts por iteración',
      postsPerIteration: 'Posts por iteración',
      postsDesc: 'Generar {count} posts por iteración',
      channels: 'Canales objetivo',
      selectChannels: 'Seleccionar canales',
      noChannels: 'Ningún canal configurado. Crea primero un canal de comunicación.',
    },
    publication: {
      title: 'Publicación automática',
      enabled: 'Activado',
      frequency: 'Frecuencia (días)',
      frequencyDesc: 'Publicar cada {days} días',
      postsCount: 'Número de posts por iteración',
      postsPerIteration: 'Posts por iteración',
      postsDesc: 'Publicar {count} posts por iteración',
      channels: 'Canales objetivo',
      selectChannels: 'Seleccionar canales',
      noChannels: 'Ningún canal configurado. Crea primero un canal de comunicación.',
    },
    save: 'Guardar',
    comingSoon: 'Próximamente',
    featureNotAvailable: 'Esta funcionalidad aún no está disponible',
  },

  // Galería de posts
  posts: {
    unknownChannelLabel: 'Canal desconocido',
    gallery: 'Galería de propuestas',
    queue: 'Cola',
    generate: 'Generar',
    generateNew: 'Generar nuevos posts',
    createNew: 'Crear post manualmente',
    duplicate: 'Duplicar post',
    showImage: 'Mostrar imagen',
    hideImage: 'Ocultar imagen',
    pdfAttachment: 'PDF adjunto — analizado por la IA si se genera desde el visual',
    typeYourContent: 'Escribe una idea para una publicación, una anécdota o pega un borrador...',
    draftMode: 'Modo borrador',
    publications: 'Publicaciones',
    filterByChannel: 'Filtrar por canal',
    filterByDate: 'Filtrar por fecha',
    filters: 'Filtros',
    search: 'Buscar',
    searchPlaceholder: 'Buscar posts...',
    searchPlaceholderInSpace: 'Buscar en {space}...',
    createPost: 'Crear post',
    generatePosts: 'Generar posts',
    setupIncompleteTooltip: 'Completa la configuración inicial para acceder a esta funcionalidad',
    clear: 'Limpiar',
    sortBy: 'Ordenar por',
    sortByChannel: 'Por canal',
    sortByDate: 'Por fecha',
    sortByAlphabetical: 'Alfabético',
    sortChannel: 'Canal',
    sortDate: 'Fecha',
    sortAlphabetical: 'Alfabético',
    sortAscending: 'Ascendente',
    sortDescending: 'Descendente',
    allChannels: 'Todos los canales',
    today: 'Hoy',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mes',
    allTime: 'Todo',
    sortNewest: 'Más reciente',
    sortOldest: 'Más antiguo',
    noPostsGallery: 'Ninguna propuesta de post',
    noPostsAvailable: 'Ningún post disponible',
    noPostsDescription: 'Comienza haciendo clic en "Generar nuevos posts" para crear contenido para tus canales de comunicación.',
    noPostsDescriptionReadOnly: 'Estás viendo este espacio en modo de solo lectura. Los posts publicados por el equipo aparecerán aquí en cuanto estén disponibles.',
    noPostsQueue: 'Ningún post en cola',
    dragHere: 'Arrastra y suelta posts aquí o haz clic en "Añadir a la cola"',
    scheduledFor: 'Programado para',
    generatedOn: 'Generado el',
    deleteConfirm: '¿Eliminar este post?',
    deleteDescription: 'Esta acción es irreversible. El post se eliminará permanentemente.',
    deleteConfirmDesc: 'Esta acción es irreversible. El post se eliminará permanentemente.',
    unsavedChangesTitle: 'Cambios no guardados',
    unsavedChangesDesc: 'Tienes cambios no guardados. Si continúas, se perderán.',
    continueWithoutSaving: 'Continuar sin guardar',
    publish: 'Publicar',
    publishCount: 'Publicar ({count})',
    editPostDetails: 'Detalles del post',
    editPostDescription: 'Edita el contenido del post, elige una fecha de envío y añádelo a la cola.',
    date: 'Fecha',
    period: 'Período',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    content: 'Contenido',
    channel: 'Canal',
    scheduledDate: 'Fecha programada',
    external: 'Externo',
    internal: 'Interno',
    onlyMine: 'Mis publicaciones',
    onlyMineHint: 'Mostrar solo las publicaciones que he creado',
    createdOn: 'Creado el',
    scheduledOn: 'Programado el',
    statusFilter: 'Estado',
    statusAll: 'Todos',
    statusDraft: 'Por publicar',
    statusScheduled: 'Programados',
    statusPublished: 'Publicados',
    statusChipScheduled: 'Programado',
    statusChipPublished: 'Publicado',
    statusChipFailed: 'Error',
    publishFailedTitle: 'La publicación ha fallado',
    publishFailedGeneric: 'La red social rechazó la publicación. Comprueba que el canal esté conectado y vuelve a intentarlo.',
    publishFailedAttempts: 'Intentos',
    publishFailedRetryHint: 'Corrige la publicación si es necesario y reinténtalo con «Publicar ahora».',
    sourceQualityPrimary: 'Basado en tus fuentes',
    sourceQualityWebFallback: 'Completado con búsqueda web',
    sourceQualityEsFallback: 'Basado en tu monitoreo reciente',
    sourceQualityNone: 'Generado sin fuentes',
    sourceQualityTooltipPrimary: 'La información de esta publicación proviene de artículos recopilados por tus fuentes.',
    sourceQualityTooltipWebFallback: 'Tus fuentes no cubrían este tema: una búsqueda web completó la información.',
    sourceQualityTooltipEsFallback: 'Esta publicación se basa en contenidos recientes de tu monitoreo, sin correspondencia exacta con el tema.',
    sourceQualityTooltipNone: 'No se encontró ninguna fuente relevante: el contenido es más genérico. Añade fuentes para publicaciones mejor fundamentadas.',
    scheduledCardTooltip: 'Esta publicación ya está programada — gestiónala desde la cola de publicación (columna derecha).',
    improveDiffTitle: 'Mejora propuesta',
    improveRejected: 'Mejora descartada — se conserva tu texto original',
    media: {
      replaceMediaTitle: '¿Reemplazar el medio?',
      replaceImageByCarousel: 'Esto eliminará la imagen actual y generará un carrusel en su lugar. La imagen se eliminará definitivamente. ¿Confirmar?',
      replaceCarouselByImage: 'Esto eliminará el carrusel actual y lo reemplazará con una imagen. El carrusel se eliminará definitivamente. ¿Confirmar?',
      replaceGeneric: 'Esto reemplazará el medio actual. ¿Confirmar?',
      replaceConfirm: 'Confirmar el reemplazo',
      imageReplacedToast: 'Imagen reemplazada por un carrusel',
      carouselReplacedToast: 'Carrusel reemplazado por una imagen',
    },
    deleteImageTitle: 'Eliminar imagen',
    editScheduleTitle: 'Editar fecha programada',
    publishedOn: 'Publicado el',
    publishOn: 'Publicar el',
    viewPost: 'Ver publicación',
    unschedule: 'Desplanificar',
    cannotScheduleInPast: 'No se puede programar en el pasado',
    addImage: 'Imagen',
    replaceImage: 'Reemplazar imagen',
    generateImage: 'Generar con IA',
    addContentFirst: 'Añade contenido primero',
    generatingImage: 'Generando imagen...',
    selectStyle: 'Elegir un estilo',
    selectModel: 'Modelo IA',
    imagePrompt: 'Prompt creativo',
    imageGenerated: 'Imagen generada con éxito',
    imageGenerationError: 'Error al generar la imagen',
    uploadImage: 'Subir una imagen',
    orGenerateWithAI: 'o generar con IA',
    image: {
      label: 'Imagen',
      promptPreviewLoading: 'Preparando el prompt…',
      promptPreviewError: 'No se puede generar el prompt',
      promptRateLimited: 'Inténtalo de nuevo en unos segundos',
      promptRequired: 'El prompt no puede estar vacío',
      editPrompt: 'Modificar el prompt',
      launchGeneration: 'Lanzar la generación',
      promptPlaceholder: 'Prompt en inglés para la generación…',
      resetPrompt: 'Restablecer prompt',
      editPlaceholder: 'Editar la imagen (ej: cambia el fondo, rejuvenece a la persona)…',
      editLaunch: 'Editar imagen',
      editSuccess: 'Imagen editada',
      editError: 'No se pudo editar la imagen',
      editUnsupported: 'Este modelo no permite editar imágenes',
    },
    containsImage: 'Contiene una imagen',
    edit: 'Editar',
    copy: 'Copiar',
    improve: 'Mejorar',
    improveWithAi: 'Mejorar el texto',
    improving: 'Mejorando...',
    improveDialogTitle: 'Mejorar con IA',
    improveDialogDescription: 'Describe cómo quieres mejorar esta publicación',
    improveInstructionsPlaceholder: 'Ej: Hazlo más impactante, añade emojis...',
    improveButton: 'Mejorar',
    improveSuggestions: {
      moreConcise: 'Más conciso',
      moreEngaging: 'Más atractivo',
      addHook: 'Añadir gancho',
      addCTA: 'Añadir llamada a la acción',
      shorterForX: 'Acortar para X (280 car.)',
    },
    saved: 'Guardar',
    improvedByAI: 'Contenido mejorado por IA',
    contentPlaceholder: 'Escribe tu contenido...',
    errorImprovingContent: 'Error al mejorar el contenido',
    improvedContentSuffix: '✨ Contenido mejorado por IA',
    errorUpdatingChannel: 'Error al actualizar el canal',
    htmlCopied: 'Código HTML copiado al portapapeles',
    noPostsSelected: 'Ningún post seleccionado para la generación',
    calendar: 'Calendario',
    newsletter: 'Newsletter',
    featureComingSoon: 'Esta funcionalidad estará disponible pronto',
    quickSuggestions: 'Sugerencias rápidas',
    yourInstructions: 'Tus instrucciones',
    currentContent: 'Contenido actual',
    qualityScore: 'Puntuación de calidad',
    validationUnavailable: 'No evaluado',
    validationSkippedDesc: 'La validación automática no pudo realizarse para este post.',
    retryScoring: 'Reintentar',
    retryScoringTooltip: 'Reintentar la puntuación de calidad para este post',
    rescoringInProgress: 'Puntuando…',
    rescoreRateLimited: 'Inténtalo de nuevo en unos segundos',
    rescoreSuccess: 'Puntuación reiniciada con éxito',
    rescoreError: 'No se pudo reiniciar la puntuación',
    sourcesUsed: 'Fuentes utilizadas para la generación',
    viewDetails: 'Ver detalles',
    viewSource: 'Ver fuente',
    tone: 'Tono',
    originality: 'Originalidad',
    clarity: 'Claridad',
    engagement: 'Engagement',
    relevance: 'Relevancia',
    overall: 'Global',
    copyContent: 'Copiar contenido',
    regenerate: 'Regenerar',
    regenerateSuccess: 'Nueva versión generada — encuéntrala en tu galería.',
    regenerateError: 'Error al regenerar.',
    positioningScore: 'Posicionamiento',
    toneScore: 'Tono',
    overallScore: 'Global',
    originalityScore: 'Originalidad',
    complianceFeedback: 'Comentario del agente',
    complianceIssues: 'Puntos a mejorar',
    complianceSuggestions: 'Sugerencias',
    // Tokens técnicos devueltos por el agente de compliance — humanizado ES.
    complianceFlags: {
      language_mismatch: 'Idioma incorrecto',
      freshness_risk: 'Riesgo de frescura (información antigua)',
      source_incomplete: 'Fuente incompleta o ausente',
      source_missing: 'Fuente ausente',
      unsourced_statistic: 'Estadística sin fuente',
      template_hook: 'Gancho demasiado genérico',
      generic_content: 'Contenido demasiado genérico',
      tone_mismatch: 'Tono incoherente con la marca',
      positioning_drift: 'Desvío del posicionamiento',
      originality_low: 'Originalidad baja',
      off_topic: 'Fuera de tema',
      no_cta: 'Sin llamada a la acción',
      too_long: 'Demasiado largo para la plataforma',
      too_short: 'Demasiado corto',
      hashtags_overuse: 'Demasiados hashtags',
      buzzwords_overuse: 'Demasiados buzzwords',
      missing_citation: 'Cita ausente',
      duplicate_idea: 'Idea ya presente en el lote',
    },
    noPostsForDay: 'Sin publicaciones para este día',
    schedule: 'Programar',
    publishNow: 'Publicar ahora',
    previousPage: 'Anterior',
    nextPage: 'Siguiente',
  },

  // V4-ZERNIO-ANALYTICS 2026-05-28
  analyticsTab: {
    title: 'Analíticas',
    period: 'Período:',
    days: 'd',
    impressions: 'Impresiones',
    reach: 'Alcance',
    likes: 'Me gusta',
    comments: 'Comentarios',
    engagement: 'Interacción',
    publications: 'Publicaciones',
    onPeriod: 'en los últimos {days} días',
    byNetwork: 'Por red',
    postsCount: '{count} pubs · {rate} eng.',
    impLabel: 'imp.',
    likesLabel: 'me gusta',
    noPublications: 'Sin publicaciones en este período — las analíticas aparecerán tras publicar.',
    noSpace: 'Ningún espacio seleccionado.',
    loadError: 'No se pudieron cargar las analíticas.',
    refresh: 'Actualizar',
  },

  // V4-ZERNIO-COMMENTS 2026-05-28
  engagementTab: {
    title: 'Interacción',
    statusUnreplied: 'Por responder',
    statusReplied: 'Respondidos',
    statusAll: 'Todos',
    emptyUnreplied: 'Sin comentarios pendientes — ¡bien hecho!',
    emptyOther: 'Sin comentarios.',
    noSpace: 'Ningún espacio seleccionado.',
    loadError: 'No se pudieron cargar los comentarios.',
    refresh: 'Actualizar',
    anonymous: 'Anónimo',
    replied: 'Respondido',
    yourReply: 'Tu respuesta:',
    replyPlaceholder: 'Tu respuesta…',
    cancel: 'Cancelar',
    send: 'Enviar',
    reply: 'Responder',
    like: 'Me gusta',
    alreadyLiked: 'Ya marcado',
    hide: 'Ocultar',
    alreadyHidden: 'Ya oculto',
    replySuccess: 'Respuesta publicada.',
    replyFailed: 'Error al publicar la respuesta.',
    hideSuccess: 'Comentario ocultado.',
    hideFailed: 'Error al ocultar.',
    likeFailed: 'Error al marcar me gusta.',
  },

  // V4-ZERNIO-ANALYTICS-POST-CARD 2026-05-28
  postAnalytics: {
    title: 'Analíticas del post',
    viewBtn: 'Ver analíticas del post',
    lastSnapshot: 'Última captura',
    history: 'Historial ({count} capturas)',
    refresh: 'Actualizar',
    refreshed: 'Analíticas actualizadas.',
    refreshFailed: 'Error al actualizar.',
    loadError: 'No se pudieron cargar las analíticas.',
    impressions: 'Impresiones',
    reach: 'Alcance',
    likes: 'Me gusta',
    comments: 'Comentarios',
    engagement: 'Interacción',
    shares: 'Compartidos',
    colDate: 'Fecha',
    colImpressions: 'Imp.',
    colLikes: 'Me gusta',
    colEngagement: 'Eng.',
    noSnapshot: 'Aún no hay capturas. Pulsa "Actualizar" para obtener analíticas en vivo desde Zernio.',
  },

  // Colores
  colors: {
    primary: 'Color principal',
    background: 'Superficie',
    surface: 'Fondo',
    border: 'Bordes',
    textPrimary: 'Texto principal',
    textSecondary: 'Texto secundario',
    textLight: 'Acentuación clara',
    accent: 'Acentuación oscura',
    success: 'Éxito',
    warning: 'Advertencia',
    danger: 'Peligro',
  },

  // Generación de post a partir de un visual ya cargado (imagen / carrusel / PDF)
  generateFromVisual: {
    button: 'Generar el texto a partir de este visual',
    buttonShort: 'Generar desde el visual',
    briefLabel: 'Intención / contexto (opcional)',
    briefPlaceholder: 'Ej.: anuncio de lanzamiento de producto, lección de un proyecto cliente, etc.',
    generate: 'Generar el texto',
    generating: 'Generando…',
    success: 'Texto generado a partir de tu visual',
    error: 'Error al generar a partir del visual',
    confirmOverwrite: 'El texto actual se reemplazará por el generado a partir del visual.',
    confirmOverwriteTitle: '¿Reemplazar el texto actual?',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    regenerate: 'Regenerar',
    phaseInit: 'Preparando…',
    phaseVisual: 'Analizando el visual…',
    phaseWriting: 'Redactando el post…',
    phaseCompliance: 'Validación final…',
    phaseFinalize: 'Guardando…',
  },

  // Modal de generación
  generate: {
    title: 'Generar nuevos posts',
    description: 'Selecciona los canales para los que deseas generar contenido:',
    forcedSectionTitle: 'Orientar la generación (opcional)',
    forcedTopicLabel: 'Hablar de una noticia concreta',
    forcedTopicPlaceholder: 'Ej.: el lanzamiento de GPT-5, un estudio reciente sobre el teletrabajo...',
    forcedUrlLabel: 'Forzar un enlace de fuente',
    forcedUrlPlaceholder: 'https://ejemplo.com/articulo-interesante',
    postsPerChannel: 'Número de posts por canal',
    postsCount: 'Número de posts',
    periodBack: 'Período de monitoreo',
    channels: 'Canales',
    noChannelsTitle: 'Ningún canal conectado',
    noChannelsHint: 'Conecte al menos una red social para generar publicaciones.',
    connectChannel: 'Conectar un canal',
    cancel: 'Cancelar',
    close: 'Cerrar',
    generate: 'Generar',
    start: 'Iniciar generación',
    generating: 'Generando...',
    inProgress: 'Generación en curso...',
    viewProgress: 'Ver el progreso',
    error: 'Error al generar posts',
    noPostsFound: 'No se encontraron posts en la base de datos para los criterios seleccionados.',
    fromToday: 'Desde hoy',
    backendNotDeployed: 'El servidor backend aún no está desplegado. Por favor despliega primero el servidor Supabase Edge Function a través de la línea de comandos: npx supabase functions deploy make-server-b017c5b0',
    serverError: 'Error del servidor',
    errorFetchingPosts: 'Error al recuperar los posts',
    platformPositioning: 'Posicionamiento específico',
    platformPositioningPlaceholder: 'Opcional: ángulo o tono específico para esta red (ej: más corporativo en LinkedIn, más informal en X...)',
    imageProvider: 'Generador de imágenes',
    // Zernio publishing
    publishNow: 'Publicar ahora',
    schedule: 'Programar',
    publishing: 'Publicando…',
    publishSuccess: 'Post publicado con éxito',
    publishError: 'Error al publicar el post',
    validationFailed: 'Validación fallida',
    noChannelSelected: 'Por favor seleccione un canal',
    contentEmpty: 'El contenido no puede estar vacío',
    characterLimitExceeded: 'Límite de caracteres superado',
    mediaRequired: 'Se requiere un archivo multimedia para esta plataforma',
    titleRequired: 'Se requiere un título para esta plataforma',
    // Validation messages (usePublishValidation)
    noPostSelected: 'Ningún post seleccionado',
    contentEmptyValidation: 'El contenido del post está vacío',
    characterLimitDetail: 'El contenido supera el límite ({count}/{max} caracteres)',
    nearCharacterLimit: 'Cerca del límite de caracteres ({percentage}%)',
    noChannelAssigned: 'Ningún canal de publicación asignado',
    videoRequiredFor: 'Se requiere un archivo de vídeo para {platform}',
    mediaRequiredFor: 'Se requiere un archivo multimedia (imagen o vídeo) para {platform}',
    titleRecommendedFor: 'Se recomienda un título para {platform}',
    publishAttempts: 'Intentos de publicación: {count}',
    statusPublished: 'Publicado',
    statusScheduled: 'Programado',
    statusFailed: 'Fallido',
    statusDraft: 'Borrador',
    // Pipeline de agentes
    pipeline: {
      memory:     { label: 'Memoria',    tooltip: 'Analiza el historial de publicaciones y memoriza tus preferencias editoriales.' },
      knowledge:  { label: 'Búsqueda',   tooltip: 'Recopila noticias, tendencias y fuentes relevantes de tu seguimiento.' },
      writer:     { label: 'Redacción',  tooltip: 'Redacta los posts respetando tu tono, estilo y posicionamiento.' },
      diversity:  { label: 'Variedad',   tooltip: 'Diversifica formatos, ángulos y estructuras para evitar la repetición.' },
      compliance: { label: 'Directrices',tooltip: 'Verifica la conformidad con tu guía editorial y valida el posicionamiento.' },
      finalize:   { label: 'Validación', tooltip: 'Finaliza y valida todos los posts antes de entregarlos.' },
    },
  },

  // Campos específicos por plataforma
  platformFields: {
    sectionTitle: 'Ajustes específicos de la plataforma',
    title: 'Título',
    titlePlaceholder: 'Título de la publicación',
    subreddit: 'Subreddit',
    subredditPlaceholder: 'r/misubreddit',
    flairId: 'Flair ID',
    flairIdPlaceholder: 'ID del flair (opcional)',
    boardId: 'Board de Pinterest',
    boardIdPlaceholder: 'ID del tablero de Pinterest',
    linkUrl: 'URL del enlace',
    linkUrlPlaceholder: 'https://example.com',
    visibility: 'Visibilidad',
    category: 'Categoría',
    categoryPlaceholder: 'Categoría de YouTube',
    privacyLevel: 'Privacidad',
    callToAction: 'Llamada a la acción',
    callToActionPlaceholder: 'Más información, Comprar, etc.',
    eventTitle: 'Título del evento',
    eventTitlePlaceholder: 'Nombre del evento',
    eventStart: 'Inicio del evento',
    eventEnd: 'Fin del evento',
  },
  toasts: {
    // V4-21 — Subida de medios
    uploadError: 'Error al subir la imagen. Vuelve a intentarlo.',
    // Channels
    channelAddedTitle: 'Canal añadido',
    channelAddedDesc: 'El canal {name} ha sido creado con éxito.',
    channelUpdatedTitle: 'Canal actualizado',
    channelUpdatedDesc: 'El canal {name} ha sido modificado.',
    channelNoPositioningTitle: 'Posicionamiento específico no definido',
    channelNoPositioningDesc: 'Este canal utilizará el posicionamiento general. Personaliza un posicionamiento dedicado a esta red para publicaciones mejor dirigidas.',
    channelDeletedTitle: 'Canal eliminado',
    channelDeletedDesc: 'El canal de comunicación ha sido eliminado.',
    channelAddError: 'Error al añadir el canal',
    channelUpdateError: 'Error al actualizar el canal',
    channelDeleteError: 'Error al eliminar el canal',
    channelLoadError: 'Error al cargar los canales',

    // Topics
    topicAddedTitle: 'Tema añadido',
    topicAddedDesc: 'El tema "{keywords}" ha sido creado con éxito.',
    topicUpdatedTitle: 'Tema actualizado',
    topicUpdatedDesc: 'El tema "{keywords}" ha sido actualizado.',
    topicDeletedTitle: 'Tema eliminado',
    topicDeletedDesc: 'El tema ha sido eliminado con éxito.',
    topicAddError: 'Error al añadir el tema',
    topicUpdateError: 'Error al actualizar el tema',
    topicDeleteError: 'Error al eliminar el tema',

    // Fuentes
    sourceAdded: 'Fuente añadida',
    sourceAddedDesc: 'La fuente "{name}" se ha añadido con éxito.',
    sourceUpdated: 'Fuente actualizada',
    sourceUpdatedDesc: 'Los ajustes de la fuente se han guardado.',
    sourceDeleted: 'Fuente eliminada',
    sourceDeletedDesc: 'La fuente se ha retirado de su espacio.',
    sourceUnlinked: 'Fuente desvinculada',
    sourceUnlinkedDesc: 'La fuente se ha desvinculado.',
    sourceAddError: 'Error al añadir la fuente',
    sourceUpdateError: 'Error al actualizar',
    sourceDeleteError: 'Error al eliminar',
    // V4-SOURCES-LLM-BG 2026-05-29 — FINDING-SOURCES-02
    keywordsBackground: 'Servicio temporalmente no disponible. Inténtelo en breve.',
    noSpaceSelected: 'Ningún espacio seleccionado',
    // Generación
    generating: 'Generando posts...',
    noChannelSelected: 'Ningún canal seleccionado',
    noPostGenerated: 'Ningún post generado',
    postsGenerated: '{count} post(s) generado(s) con éxito',
    postsGeneratedFeedbackHint: 'Si los resultados no cumplen sus expectativas, comparta su opinión con el agente de posicionamiento para mejorar las próximas generaciones.',
    partialGeneration: '{delivered} de {requested} post(s) solicitado(s) generado(s) — contenido demasiado similar, pruebe con otro tema.',
    generationCancelled: 'Generación cancelada',
    generationError: 'Error: {message}',
    generationTimeout: 'La generación ha expirado',
    generationTimeoutDesc: 'El servicio está lento en este momento. Puede volver a intentarlo en un momento.',
    imageGenerationTimeout: 'La generación de imagen ha expirado',
    imageGenerationTimeoutDesc: 'El servicio está lento en este momento. Puede volver a intentarlo en un momento.',
    fromVisualTimeout: 'La generación a partir del visual ha expirado',
    fromVisualTimeoutDesc: 'El servicio está lento en este momento. Puede volver a intentarlo en un momento.',
    retry: 'Reintentar',
    // Detección de nueva versión (bundle SPA obsoleto)
    updateAvailableTitle: 'Nueva versión disponible',
    updateAvailableDesc: 'Recarga la página para aplicar la actualización.',
    reload: 'Recargar',
    // Mejora
    improving: 'Mejorando post...',
    postImproved: 'Post mejorado',
    improveError: 'Error: {message}',
    improveTimeout: 'La mejora ha expirado',
    improveTimeoutDesc: 'El servicio está lento en este momento. Puede volver a intentarlo en un momento.',
    // Sincronización
    syncing: 'Sincronizando fuentes...',
    syncSuccess: '{count} fuente(s) sincronizada(s)',
    syncError: 'Error al sincronizar las fuentes',
    sourceSyncing: 'Sincronizando fuente...',
    sourceSyncSuccess: 'Fuente sincronizada con éxito',
    sourceSyncError: 'Error al sincronizar la fuente',
    sourceSyncTimeout: 'La sincronización continúa en segundo plano...',
    syncAllStarted: 'Sincronización secuencial de {count} fuente(s)...',
    syncAllCompleted: 'Todas las fuentes se han sincronizado',
    syncAllPartial: '{success} fuente(s) sincronizada(s), {failed} con error',
    // Copia
    contentCopied: 'Contenido copiado al portapapeles',
    copyError: 'No se pudo copiar el contenido',
    // Posts
    postSaved: 'Post guardado',
    postSavedDesc: 'Tus modificaciones han sido guardadas con éxito',
    postUpdated: 'Post actualizado',
    postUpdatedDesc: 'Las modificaciones han sido guardadas en tu galería',
    postCreated: 'Post creado',
    postCreatedDesc: 'Tu nuevo post ha sido añadido a la galería',
    postDeleted: 'Post eliminado',
    postDeletedDesc: 'El post ha sido eliminado de la lista',
    postScheduled: 'Post programado',
    postScheduledDesc: 'El post ha sido añadido a la cola',
    scheduleFailed: 'No se pudo programar',
    scheduleFailedDesc: 'No se pudo programar el post. Inténtalo de nuevo.',
    postPublished: 'Post publicado',
    postPublishedDesc: 'El post ha sido publicado con éxito a través de Late',
    postPublishError: 'Error de publicación',
    postPublishErrorDesc: 'No se puede publicar el post: {error}',
    postDuplicated: 'Post duplicado',
    postDuplicatedDesc: 'Una copia del post ha sido añadida a la galería',
    postChannelUpdated: 'Canal actualizado',
    postChannelUpdatedDesc: 'El post ahora está asociado a este nuevo canal',
    imageAdded: 'Imagen añadida',
    imageAddedDesc: 'La imagen ha sido asociada al post',
    imageRemoved: 'Imagen eliminada',
    imageRemovedDesc: 'La imagen ha sido retirada del post',
    galleryCleared: 'Galería vaciada',
    galleryClearedDesc: 'Todos los posts han sido eliminados',
    // Newsletter
    newsletterGenerated: 'Newsletter generada con {count} post(s)',
    // Posicionamiento
    positioning: {
      saveSuccess: 'Posicionamiento guardado',
      saveError: 'Error al guardar el posicionamiento',
      loadError: 'Error al cargar el posicionamiento',
    },
    saveError: 'Error al guardar la configuración',
    // V4-POS-06 2026-05-29 — fallback scraping URL degradado
    scrapingDegraded: 'Análisis del sitio temporalmente no disponible — el asistente continúa sin él.',
    // General
    success: 'Éxito',
    error: 'Error',
    warning: 'Advertencia',
    info: 'Información',
  },

  // Modal de confirmación
  confirm: {
    clearGalleryTitle: 'Confirmación de eliminación',
    clearGalleryDescription: '¿Confirmas la eliminación de todos los posts de la galería?',
    clearGalleryQuestion: '¿Vaciar galería?',
    clearGalleryWarning: 'Esta acción eliminará todos los posts de la galería.',
    irreversible: 'Esta acción es irreversible.',
    cancel: 'Cancelar',
    clearGallery: 'Vaciar galería',
    delete: '¿Estás seguro de que deseas eliminar este elemento?',
    unsavedChanges: 'Tienes cambios sin guardar. ¿Deseas continuar?',
    confirmDeleteAllData: '¿Estás seguro de que quieres eliminar todos los datos?',
  },

  // Modal de publicaciones
  publications: {
    title: 'Publicaciones programadas',
    description: 'Lista de todos los posts publicados',
    noPublications: 'Ninguna publicación programada',
    publishedOn: 'Publicado el',
    at: 'a las',
    delete: 'Eliminar',
    deleteConfirm: '¿Eliminar esta publicación?',
    deleteDescription: 'Esta acción es irreversible. La publicación se eliminará permanentemente.',
  },

  // Tutorial de Youtube
  youtubeTutorial: {
    title: 'Cómo encontrar el ID de canal de YouTube',
    description: 'Guía para encontrar el identificador único de un canal de YouTube',
    method1Title: 'Método 1: A través de la página "Acerca de"',
    method1Step1: 'Accede al canal de YouTube deseado',
    method1Step2: 'Haz clic en la pestaña "Acerca de"',
    method1Step3: 'Haz clic en "Compartir" y luego "Copiar ID del canal"',
    method2Title: 'Método 2: A través de la URL del canal',
    method2Step1: 'Ve a la página del canal de YouTube',
    method2Step2: 'Mira la URL en la barra de direcciones',
    method2Step3: 'El ID del canal generalmente comienza con "UC" y contiene 24 caracteres',
    method2ExampleUrl: 'Ejemplo de URL:',
    method3Title: 'Método 3: Para canales con @username',
    method3Step1: 'Si el canal usa un @username (ej: @miusuario)',
    method3Step2: 'Ve a youtube.com/@miusuario',
    method3Step3: 'Haz clic derecho → "Ver código fuente de la página"',
    method3Step4: 'Busca "channelId" en el código (Ctrl+F)',
    method3Step5: 'El ID del canal está justo después',
    tip: 'Consejo:',
    tipText: 'El ID de canal de YouTube (Canonical ID) siempre comienza con "UC" y contiene exactamente 24 caracteres alfanuméricos.',
    example: 'Ejemplo:',
    gotIt: 'Entendido',
  },

  // Botones comunes
  common: {
    freePlan: 'Plan Free',
    reactivate: 'Reactivar',
    draft: 'Borrador',
    save: 'Guardar',
    cancel: 'Cancelar',
    selectAll: 'Seleccionar todo',
    deselectAll: 'Deseleccionar todo',
    selectedLabel: 'seleccionados',
    addSelection: 'Añadir selección',
    adding: 'Añadiendo…',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Añadir',
    close: 'Cerrar',
    confirm: 'Confirmar',
    loading: 'Cargando...',
    copy: 'Copiar',
    back: 'Atrás',
    next: 'Siguiente',
    search: 'Buscar',
    filter: 'Filtrar',
    reset: 'Restablecer',
    refresh: 'Actualizar',
    validate: 'Validar',
    saveChanges: 'Guardar cambios',
    unknownChannel: 'Canal desconocido',
    confirmDeleteAllData: '¿Está seguro de que desea eliminar todos los datos?',
    type: 'Tipo',
    weekDays: ['L', 'M', 'M', 'J', 'V', 'S', 'D'],
    characters: 'caracteres',
    viewSource: 'Ver fuente',
    others: 'otros',
    or: 'o',
    optional: 'opcional',
  },

  // Tiempo relativo
  time: {
    justNow: 'Ahora mismo',
    minutesAgo: 'hace {count} min',
    hoursAgo: 'hace {count}h',
    daysAgo: 'hace {count}d',
    neverSynced: 'Nunca sincronizado',
  },

  // Tipos de fuentes para trazabilidad
  sourceTypes: {
    rss: 'Feed RSS',
    rss_feed: 'Feed RSS',
    youtube: 'YouTube',
    video: 'Video',
    website: 'Sitio web',
    url: 'URL',
    raw_text: 'Texto libre',
    text: 'Texto',
    document: 'Documento',
    pdf: 'PDF',
    podcast: 'Podcast',
    unknown: 'Fuente',
  },

  // Sesión expirada
  session: {
    expiredTitle: 'Sesión expirada',
    expiredDescription: 'Tu sesión ha expirado. Por favor, inicia sesión de nuevo.',
  },

  // Ayuda YouTube para SourceForm
  youtubeHelp: {
    title: '💡 Cómo encontrar el ID del canal de YouTube:',
    step1: 'Ve a la página del canal de YouTube',
    step2: 'El ID se encuentra en la URL:',
    step3: 'O haz clic derecho → "Ver código fuente de la página" → Busca "channelId"',
    note: 'El ID siempre comienza con "UC" seguido de 22 caracteres.',
    rawTextHelp: 'Pega aquí tus notas internas, información de vigilancia, o cualquier contenido que quieras usar para la generación de posts.',
  },

  // Componentes UI genéricos
  ui: {
    sidebar: {
      title: 'Barra lateral',
      mobileDescription: 'Muestra la barra lateral móvil',
    },
    carousel: {
      previous: 'Diapositiva anterior',
      next: 'Diapositiva siguiente',
    },
    pagination: {
      more: 'Más páginas',
      next: 'Siguiente',
      previous: 'Anterior',
    },
    dialog: {
      close: 'Cerrar',
    },
  },

  // OAuth / Conexión de redes sociales
  // Modal de selección de cuenta (OAuth headless)
  accountSelection: {
    title: 'Conectar {platform}',
    loading: 'Cargando...',
    noOptions: 'No hay opciones disponibles.',
    retryButton: 'Reintentar',
    connectButton: 'Conectar',
    connecting: 'Conectando...',
    loadError: 'No se pueden cargar las opciones. Por favor, inténtelo de nuevo.',
    connectError: 'Error de conexión. Por favor, inténtelo de nuevo.',
    subtitles: {
      linkedin: 'Elige cómo quieres publicar',
      facebook: 'Elige la página desde la que publicar',
      pinterest: 'Elige el tablero a conectar',
      googlebusiness: 'Elige tu establecimiento',
      snapchat: 'Elige tu perfil público',
      default: 'Elige una cuenta',
    },
  },

  oauth: {
    connect: 'Conectar {{network}}',
    connecting: 'Conectando...',
    disconnect: 'Desconectar',
    refresh: 'Actualizar token',
    notSupported: 'OAuth no disponible',
    confirmDisconnect: '¿Estás seguro de que quieres desconectar esta cuenta?',
    confirmDisconnectTitle: 'Desconectar cuenta',
    confirmDisconnectDescription: '¿Estás seguro de que quieres desconectar esta cuenta? El historial no será eliminado.',
    confirmDisconnectAction: 'Desconectar',
    connected: 'Conectado',
    needsRefresh: 'Token expirado',
    expired: 'No conectado',
    error: 'Error de conexión',
    success: '¡Conectado!',
    selectPage: 'Seleccionar una página',
    selectAccount: 'Seleccionar una cuenta',
    noPages: 'No se encontraron páginas de Facebook',
    noAccounts: 'No se encontraron cuentas de Instagram',
    pageRequired: 'Debes seleccionar una página para publicar',
    accountRequired: 'Debes seleccionar una cuenta de Instagram para publicar',
    processing: 'Conectando...',
    processingMessage: 'Por favor espera mientras finalizamos la conexión.',
    successMessage: 'Tu cuenta ha sido conectada con éxito. Esta ventana se cerrará automáticamente.',
  },

  // Zernio / Conexión de redes sociales via Zernio (getlate.dev)
  socials: {
    connect: 'Conectar cuenta',
    connecting: 'Conectando…',
    connected: 'Conectado',
    disconnect: 'Desconectar',
    reconnect: 'Reconectar',
    refreshConnection: 'Actualizar conexión',
    expired: 'Token expirado',
    notConnected: 'No conectado',
    connectNow: 'Conectar ahora',
    connectPrompt: 'Conecta esta red para publicar tus posts',
    connectReminderTitle: 'Canal creado — conéctalo ahora',
    connectReminderBody: 'Conecta tu red para poder publicar los posts generados.',
    notSupported: 'No soportado',
    confirmDisconnect: '¿Estás seguro de que quieres desconectar esta cuenta social?',
    confirmDisconnectTitle: 'Desconectar cuenta',
    confirmDisconnectDescription: '¿Estás seguro de que quieres desconectar esta cuenta social? El historial no será eliminado.',
    confirmDisconnectAction: 'Desconectar',
    manage: 'Gestionar conexión',
    callbackProcessing: 'Finalizando conexión…',
    callbackSuccess: '¡Cuenta conectada con éxito! Esta ventana se cerrará.',
    callbackError: 'Error de conexión. Por favor, inténtalo de nuevo.',
    channelsUsed: 'canales usados',
    tokenExpiresIn: 'Expira en {{days}} días',
    tokenExpiresSoon: 'Token expira pronto',
    reconnectRequired: 'Reconexión necesaria',
    telegramConnected: 'Telegram conectado',
    telegramCodeExpired: 'Código expirado, inténtelo de nuevo',
    codeCopied: 'Código copiado',
    telegramSetup: 'Conexión Telegram',
    telegramInstructions: 'Instrucciones:',
    telegramStep1: 'Añada @LateScheduleBot como administrador en su canal/grupo',
    telegramStep2: 'Abra un chat privado con @LateScheduleBot',
    telegramStep3: 'Envíe el código de arriba seguido de @sucanal',
    telegramStep4: 'Espere la confirmación automática arriba',
    openBot: 'Abrir @LateScheduleBot',
    profileAlreadyExists: 'Ya existe un perfil con este nombre en esta plataforma.',
    connectionError: 'Error al conectar la cuenta social.',
    popupBlocked: 'Ventana emergente bloqueada. Permite las ventanas emergentes para este sitio e inténtalo de nuevo.',
  },

  // Idiomas disponibles
  languages: {
    fr: 'Français',
    en: 'English',
    es: 'Español',
    de: 'Deutsch',
    it: 'Italiano',
    pt: 'Português',
    nl: 'Nederlands',
    pl: 'Polski',
    ru: 'Русский',
    zh: '中文',
    ja: '日本語',
    ar: 'العربية',
  },

  // WebSocket Messages (standardized i18n keys from backend)
  quota: {
    aiCredits: 'Créditos AI',
    used: 'utilizado',
    warning: 'Atención: consumo elevado de créditos AI',
    exceeded: 'Cuota superada — renovación el 1 del próximo mes',
    accountTitle: 'Mi cuenta',
    creditsSection: 'Consumo AI',
    creditsDescription: 'Su consumo de créditos AI para el período actual.',
    renewal: 'Renovación automática cada 1 de mes.',
    quotaExceededToast: 'Créditos AI agotados. Renovación automática el 1 del próximo mes.',
    quotaExceededTopupToast: 'Créditos AI agotados. Recargue sus créditos o espere la renovación el 1 del mes.',
    quotaExceededTooltip: 'Cuota AI agotada — renovación el 1 del mes.',
    quotaExceededTitle: 'Cuota AI superada',
    textBudget: 'Presupuesto texto',
    images: 'Imágenes',
    videos: 'Vídeos',
    comingSoon: 'Próximamente',
    subscription: 'Suscripción',
    of: 'de',
    // Topup
    purchasedCredits: 'Créditos comprados',
    topupTitle: 'Recargar sus créditos AI',
    topupDescription: 'Compre créditos adicionales para su cuenta.',
    topupPlanInfo: 'Recargue sus créditos AI',
    topupOneTime: 'Pago único — créditos persistentes',
    topupBuyButton: 'Comprar créditos',
    topupClose: 'Cerrar',
    topupLoading: 'Cargando...',
    topupQuantity: 'Cantidad',
    topupCreditsLabel: 'Créditos',
    topupUnitPrice: 'Precio unitario',
    topupCreditsUnit: 'créditos',
    topupCurrentBalance: 'Créditos comprados restantes:',
    topupSuccessTitle: '¡Recarga exitosa!',
    topupSuccessMessage: '¡Sus créditos AI han sido recargados exitosamente!',
    topupErrorTitle: 'Error',
    topupLoadError: 'Error al cargar la información de recarga.',
    topupPurchaseError: 'Error en la recarga. Por favor, inténtelo de nuevo.',
    topupCancelledMessage: 'Recarga cancelada.',
    topupVatAtCheckout: 'IVA calculado al pagar',
  },
  ws: {
    fallbackStep: 'Procesando…',
    generation: {
      started: 'Generando {{count}} publicación(es) para {{platform}}...',
      connecting: 'Conectando al servidor...',
      completed: '✓ {{count}} publicación(es) generada(s)',
      failed: '❌ Error: {{error}}',
    },
    memory: {
      loading: 'Cargando historial...',
      loaded: '{{posts_count}} publicaciones y {{hooks_count}} ganchos cargados',
    },
    knowledge: {
      searching: 'Buscando fuentes relevantes...',
      semantic_search: 'Análisis semántico en curso...',
      extracting_metadata: 'Extrayendo metadatos...',
      extracting_facts: 'Extrayendo datos clave...',
      found: '{{sources_count}} fuente(s) y {{facts_count}} dato(s) encontrados',
      none: 'No se encontraron fuentes relevantes',
    },
    writing: {
      started: 'Redactando {{count}} publicación(es) para {{platform}}...',
      post: 'Redactando publicación {{index}}/{{total}}...',
      shortening: 'Optimizando longitud de la publicación {{index}}...',
      completed: '{{count}} publicación(es) redactada(s)',
      error: 'Error de redacción: {{error}}',
    },
    diversity: {
      checking: 'Verificando diversidad de {{count}} publicación(es)...',
      passed: '✓ {{valid_count}} publicación(es) validada(s)',
      regenerating: '🔄 Regenerando {{invalid_count}} publicación(es) (intento {{attempt}}/{{max_attempts}})...',
    },
    compliance: {
      validating: 'Validando {{count}} publicación(es)...',
      analyzing: 'Analizando publicación {{index}}/{{total}}...',
      approved: '✓ {{count}} publicación(es) aprobada(s)',
      needs_revision: '{{count}} publicación(es) necesitan revisión',
      iterating: '🔄 Iteración {{iteration}}/{{max_iterations}} en curso...',
    },
    finalize: {
      saving: 'Guardando publicaciones...',
    },
    fallback: {
      started: 'Modo de respaldo activado...',
      completed: '{{count}} publicación(es) generada(s) (modo respaldo)',
    },
  },

  billing: {
    title: 'Facturación',
    subscription: 'Suscripción',
    currentPlan: 'Plan actual',
    email: 'Email de facturación',
    invoices: 'Facturas',
    noInvoices: 'No hay facturas por el momento.',
    downloadPdf: 'Descargar PDF',
    couponUsed: 'Código promo',
    promoCode: 'Código promo',
    promoCodePlaceholder: 'Ingrese su código promo',
    apply: 'Aplicar',
    toasts: {
      couponApplied: 'Código promo aplicado con éxito.',
      couponError: 'Código promo inválido o expirado.',
      pdfError: 'No se pudo recuperar la factura.',
      switchIntervalUpdated: 'Tu suscripción ha sido actualizada.',
      switchIntervalError: 'No se pudo actualizar tu suscripción. Inténtalo de nuevo más tarde.',
      cancelError: 'No se pudo cancelar tu suscripción. Inténtalo de nuevo más tarde.',
      referralCodeError: 'No se pudo generar tu código de referido. Inténtalo de nuevo más tarde.',
    },
    billingInterval: 'Facturación',
    monthly: 'Mensual',
    annual: 'Anual',
    switchToAnnual: 'Cambiar a anual',
    switchToMonthly: 'Cambiar a mensual',
    saveWithAnnual: 'Ahorre ~17% con la facturación anual',
    switchIntervalConfirm: 'Será redirigido a la página de pago para actualizar su suscripción.',
    cancelSubscription: 'Cancelar mi suscripción',
    cancelConfirmTitle: '¿Cancelar su suscripción?',
    cancelConfirmMessage: 'Su acceso se mantendrá hasta el final de su período de facturación actual.',
    cancelConfirmButton: 'Confirmar cancelación',
    subscriptionCancelled: 'Suscripción cancelada. Acceso mantenido hasta el final del período.',
    subscriptionEndsAt: 'Acceso hasta',
    statusCancelling: 'Cancelando',
    autoRenewal: 'Renovación automática',
    autoRenewalActive: 'Activo',
    paymentFailed: 'Fallo en el pago',
    paymentFailedDescription: 'Actualice su método de pago antes del {date} para mantener su acceso Pro.',
    paymentFailedExpired: 'Su acceso Pro ha sido suspendido debido a un fallo de pago.',
    updatePaymentMethod: 'Actualizar método de pago',
    deleteAccount: 'Eliminar mi cuenta',
    deleteAccountTitle: '¿Eliminar su cuenta?',
    deleteAccountWarning: 'Esta acción es irreversible. Su suscripción será cancelada y su cuenta desactivada.',
    deleteAccountPasswordLabel: 'Confirme su contraseña',
    deleteAccountPasswordPlaceholder: 'Ingrese su contraseña actual',
    deleteAccountConfirmButton: 'Eliminar permanentemente',
    deleteAccountSuccess: 'Cuenta eliminada con éxito.',
    deleteAccountPasswordError: 'Contraseña incorrecta.',
    referralTitle: 'Referidos',
    referralCode: 'Su código de referido',
    referralCopied: '¡Código copiado!',
    referralCopyButton: 'Copiar',
    referralCount: 'Referidos',
    referralCountOf: 'de',
    referralNoCode: 'Generar su código',
    referralGenerating: 'Generando...',
    myRewards: 'Mis recompensas',
    noRewards: 'No hay recompensas disponibles',
    rewardUsed: 'Usado',
    applyToRenewal: 'Aplicar a la renovación',
    rewardApplied: '¡Recompensa aplicada a su suscripción!',
    rewardApplyError: 'Error al aplicar la recompensa',
    upgradePlan: 'Cambiar a un plan de pago',
    choosePlan: 'Elegir',
    upgradeTitle: 'Cambiar suscripción',
    selectInterval: 'Facturación',
  },

  // V4-ACCOUNT-01 2026-05-29 — Etiquetas y textos pestaña Cuenta
  account: {
    roleUser: 'Usuario',
    roleAdmin: 'Administrador',
    roleViewer: 'Lector',
    roleAgency: 'Agencia',
    roleAgencyOwner: 'Propietario de agencia',
    roleAgencyAdmin: 'Administrador de agencia',
    roleAgencyMember: 'Miembro de agencia',
    applyPromoCode: 'Aplicar código promocional',
    referralDescription: 'Invita a colegas y gana créditos por cada registro confirmado.',
    referralLearnMore: 'Más información',
  },

  // Errores HTTP globales (apiClient)
  errors: {
    forbidden: 'Acceso denegado',
    forbiddenDescription: 'No tiene los permisos necesarios para realizar esta acción.',
    tooManyRequests: 'Demasiadas solicitudes',
    tooManyRequestsDescription: 'Ha alcanzado el límite de solicitudes. Vuelva a intentarlo en un momento.',
    serverError: 'Error del servidor',
    serverErrorDefault: 'Se ha producido un error en el servidor.',
    // V4-APICLIENT-INTERCEPTOR 2026-05-29 — mapping de errores tipadas backend
    urlScrapingFailed: 'No se pudo analizar la URL',
    urlScrapingFailedDescription: 'No se pudo obtener el contenido de la página. Verifique la URL o vuelva a intentarlo.',
    llmWorkerUnavailable: 'Servicio IA momentáneamente no disponible',
    llmWorkerUnavailableDescription: 'El worker LLM no responde. Vuelva a intentarlo en unos momentos.',
    recursionLimitExceeded: 'Generación interrumpida',
    recursionLimitExceededDescription: 'El agente alcanzó su límite de razonamiento. Simplifique la solicitud o vuelva a intentarlo.',
    upstreamLlmTimeout: 'Tiempo de espera IA superado',
    upstreamLlmTimeoutDescription: 'El proveedor LLM tardó demasiado en responder. Vuelva a intentarlo.',
    agencyPermissionsUnavailable: 'No se pudieron verificar los permisos',
    agencyPermissionsUnavailableDescription: 'No se pudieron verificar sus derechos de acceso en este momento. Vuelva a intentarlo en unos instantes.',
    badRequest: 'Solicitud no válida',
    badRequestDescription: 'La solicitud enviada no se pudo procesar.',
  },

  carousel: {
    title: 'Carrusel',
    generate: 'Generar un carrusel',
    generating: 'Generando…',
    backgroundStarted: 'Generación del carrusel iniciada',
    backgroundStartedDescription: 'Puede cerrar esta ventana. El carrusel se asociará automáticamente a la publicación.',
    editCarousel: 'Editar carrusel',
    addCarousel: 'Añadir carrusel',
    removeCarousel: 'Eliminar carrusel',
    fullRegenerationTitle: 'Regeneración completa',
    fullRegenerationDescription: 'Lance una nueva versión completa del carrusel para explorar otra dirección creativa.',
    slideRegenerationTitle: 'Regeneración de la diapositiva seleccionada',
    selectedSlideLabel: 'Diapositiva seleccionada',
    clearInstructions: 'Borrar',
    closeEditor: 'Cerrar editor',
    deleteSectionTitle: 'Eliminar carrusel',
    deleteSectionDescription: 'Esta acción desvincula el carrusel de la publicación y elimina también sus archivos almacenados.',
    deleteConfirm: 'Confirmar eliminación',
    deleteSuccess: 'Carrusel eliminado',
    deleteError: 'Error al eliminar el carrusel',
    containsCarousel: 'Contiene un carrusel',
    slides: 'Diapositivas',
    slide: 'Diapositiva',
    slideOf: 'Diapositiva {current} de {total}',
    aspectRatio: 'Formato',
    nSlides: 'Número de diapositivas',
    regenerateSlide: 'Regenerar esta diapositiva',
    regenerating: 'Regenerando…',
    instructions: 'Instrucciones de modificación',
    instructionsPlaceholder: 'Ej.: Haz esta diapositiva más impactante con un fondo más oscuro…',
    exportPng: 'Exportar como PNG',
    exportPdf: 'Exportar como PDF',
    exportPdfSuccess: 'PDF generado',
    exportPdfError: 'Error al generar el PDF',
    exporting: 'Exportando…',
    exportSuccess: '¡Carrusel exportado!',
    exportError: 'Error al exportar',
    generationError: 'Error al generar el carrusel',
    postNotFound: 'Esta publicación ya no existe. Actualiza la página e inténtalo de nuevo.',
    reorderHint: 'Arrastra y suelta para reordenar las diapositivas',
    noSlides: 'Sin diapositivas',
    previewTitle: 'Vista previa del carrusel',
    chatPlaceholder: 'Describe el carrusel a generar…',
    sendMessage: 'Generar',
    ratio_1_1: 'Cuadrado (1:1)',
    ratio_4_5: 'Retrato (4:5)',
    ratio_9_16: 'Stories / Reels (9:16)',
  },
  newsletterTemplate: {
    documentTitle: 'Newsletter',
    heading: '🚀 Tu resumen',
    subtitle: 'Las noticias esenciales, directamente en tu bandeja de entrada',
    introHeading: 'En este número',
    introBody: 'Descubre la selección de noticias y tendencias elegidas para ti en este periodo.',
    ctaHeading: '¿Quieres saber más?',
    ctaLabel: 'Descubre nuestras soluciones',
    postImageAlt: 'Ilustración de la publicación',
    rights: 'Todos los derechos reservados',
    subscriptionNotice: 'Recibes este correo porque estás suscrito a nuestra newsletter.',
  },
};